import React, {Component, lazy} from "react";
import axios from "axios";
import {Buffer} from "buffer";
import {Routes, Route, Outlet, Link, Navigate} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import jQuery from "jquery";
import {Modal} from "bootstrap";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import Menu from "./components/Menu";
import {sliderPropTypes} from "rsuite/esm/Slider/Slider";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import {DatePicker} from "rsuite";
// import "rsuite/dist/rsuite.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";

// import "./styles.scss";
// import "./menu.scss";
// import logo from "./images/logo.png";
// import influxLogo from "./images/influx-logo.svg";
// import bannerLogo from "./images/Banner.png";
// import {GoLocation} from "@react-icons/all-files/go/GoLocation";
// import {GiPopcorn} from "@react-icons/all-files/gi/GiPopcorn";
// import {GiTicket} from "@react-icons/all-files/gi/GiTicket";
// import {FiClock} from "@react-icons/all-files/fi/FiClock";
// import {BiChevronLeftCircle} from "@react-icons/all-files/bi/BiChevronLeftCircle";
// import {BiChevronRightCircle} from "@react-icons/all-files/bi/BiChevronRightCircle";

const Home = lazy(() => import("./components/Home"));
// const Menu = lazy(() => import("./components/Menu"));

// var accessTokenExpiry = 300;
var scrlFlag = 0;
var modifierGroupsArray = [];
// var smartModifiersArray = [];

// var modifierModal = null;
// var membersLoginModal = null;
var ageRestrictionModal = null;
// var orderCancellationModal = null;

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      compHomeSelectedOptions: {},
      fnbMenuRedirect: false,
      selectionPageRedirect: false,
      // yourSelectionBlock: false,
      modifiersModalDrawer: false,
      fnbMenuData: [],
      cartData: [],
      fnbItemData: [],
      fnbItemModifierData: [],
      tempModifierModalTotal: 0,
      createOrderData: {
        firstname: "",
        lastname: "",
        fullname: "",
        email: "",
        phonenumber: "",
        //seatNumber: "", // Change of key seatNumber to deliveryseat
        deliveryseat: "",
        termsAndConditions: false,
      },
      cartDrawer: false,
      repeatItemData: {},
      repeatItemModalDrawer: false,
      upsizeModalDrawerFlag: false,
      repeatItemIllChoose: false,
      setReviewScreenCartDataCount: false,
      windowWidth: window.innerWidth,
      requiredModifierGroupCount: 0,
      upsizeProceedFlag: false,
      //>// upsizeFrom: "",
      upsizeIsUpsize: 0,
      upsizePriceDifferent: 0,
      alcoholDisableBtn: false,
      alchocolDetailsData: {},
      alcoholAgeValidation: false,
      alcholBeverageCheckFNBData: {
        fnbItemData: [],
        MenuId: "",
      },
      salesItemModalDrawer: false,
      salesItemsData: {},
    };
    // this.accordionBodyWidthRef = React.createRef();
  }
  componentDidMount() {
    console.log("componentDidMount()");
    var self = this;
    window.addEventListener("resize", this.handleWindowResize);
    // try {
    //   if (JSON.parse(localStorage.getItem("stateData")) !== null) {
    //     let compHomeSelectedOptions = JSON.parse(localStorage.getItem("stateData")).compHomeSelectedOptions;
    //     this.setState({compHomeSelectedOptions});
    //   }
    // } catch (e) {
    //   console.log(e);
    // }
    if (window.location.pathname == process.env.REACT_APP_SERVER_FOLDER_NAME + "/fnbmenu" || window.location.pathname.toString().includes("fnbmenu")) {
      this.setState(JSON.parse(localStorage.getItem("stateData")), () => {
        //>// this.checkIfUserLoggedin();

        // Edit Flow from review page - populate cardData(app state) using fnbCartData(localstorage) & menusselected(cookie)
        console.log(this.state.setReviewScreenCartDataCount);
        console.log(JSON.parse(localStorage.getItem("fnbCartData")));
        if (this.state.setReviewScreenCartDataCount == false && JSON.parse(localStorage.getItem("fnbCartData")) !== null) {
          this.setReviewScreenCartData();
        }
      });
    } else {
      localStorage.removeItem("stateData");
      //>// localStorage.removeItem("dealWidth");
    }

    /* Jquery Window Load & Resize */
    jQuery(window).on("load resize", function () {
      //Space Calculation: to fix last(active) & its previous(focus) different classes.
      if (
        jQuery(".pcpFnbblock .pcpfnbCategory ul li:not('.animateLi')").length > 0 &&
        jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li").length > 0 &&
        jQuery(".pcpFnbblock .pcpfnbCategory ul li:not('.animateLi')").length == jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li").length
      ) {
        //////////console.log("asdfasdf");
        setTimeout(function () {
          self.bottomSpacecalculation();
        }, 1000);
      }
    });

    /* Jquery Window Scroll */
    jQuery(window).on("scroll", function () {
      //Space Calculation: to fix last(active) & its previous(focus) different classes.
      if (
        jQuery(".pcpFnbblock .pcpfnbCategory ul li:not('.animateLi')").length > 0 &&
        jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li").length > 0 &&
        jQuery(".pcpFnbblock .pcpfnbCategory ul li:not('.animateLi')").length == jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li").length &&
        scrlFlag == 0
      ) {
        //////////console.log("asdfasdf");
        scrlFlag = 1;
        setTimeout(function () {
          self.bottomSpacecalculation();
        }, 1000);
      }
    });

    /* Jquery Window Load & Scroll */
    jQuery(window).on("load scroll", function () {
      //Header Sticky
      if (jQuery("header.pageHeader").length > 0 && !jQuery("body").hasClass("noStickyHeader")) {
        var stopVal = jQuery(this).scrollTop();
        if (stopVal > 0) {
          jQuery("body").addClass("phSticky");
        } else {
          jQuery("body").removeClass("phSticky");
        }
      }
    });

    /* Jquery Window Load, Resize & Scroll */
    jQuery(window).on("load resize scroll", function () {
      // // // // // console.log("Jquery Window Load, Resize & Scroll");
      /* Right Column - Sticky & mcustomScrollbar initialize/destroy */
      if (jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColleft").length > 0 && jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright").length > 0) {
        var lftColheight = jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColleft").outerHeight(true);
        var rgtColheight = jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright").outerHeight(true);
        // // // // // console.log("lftColheight: " + lftColheight);
        // // // // // console.log("rgtColheight: " + rgtColheight);
        /*Left Column height less than right column height*/
        if (rgtColheight > lftColheight && jQuery(window).width() > 992) {
          var wnwHeight = jQuery(window).height();
          // // // // // var hdrHeight = jQuery(".pageHeader").outerHeight(true);
          // // // // // hdrHeight = 0; //***Option to remove fixed header.
          var hdrHeight = jQuery(".header").outerHeight(true);
          hdrHeight = jQuery(window).width() > 1023 ? hdrHeight : 0;
          var ftrHeight = jQuery(".pageFooter").outerHeight(true);
          var calmrgbtm = parseInt(wnwHeight - (hdrHeight + lftColheight + ftrHeight + 20));
          // // // // // console.log("calmrgbtm: " + calmrgbtm);
          if (calmrgbtm >= 0) {
            jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColleft").css("margin-bottom", calmrgbtm);
            jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright").css("min-height", wnwHeight - (hdrHeight + ftrHeight));
          } else {
            jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColleft").css("margin-bottom", "");
            jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright").css("min-height", "");
          }
        } else {
          jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColleft").css("margin-bottom", "");
          jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright").css("min-height", "");
        }
        /*E.O. Left Column height less than right column height*/

        var stopVal = jQuery(this).scrollTop();
        var fnbpost = jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright").offset().top;
        // // // // // var hHeight = jQuery(".pageHeader").outerHeight(true);
        // // // // // hHeight = 0; //***Option to remove fixed header.
        var hHeight = jQuery(".header").outerHeight(true);
        hHeight = jQuery(window).width() > 1023 ? hHeight : 0;
        var tHeight = jQuery("#pcpfnbCategorywrapper").length > 0 ? jQuery("#pcpfnbCategorywrapper").outerHeight(true) : 0;

        var caltrgt = parseInt(fnbpost - hHeight - tHeight);
        var topGutr = 0; //padding-top value of --> .pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright:not(.sticky) .pcpbicrInner.
        if (jQuery(window).width() > 992) {
          topGutr = 10;
        } else if (jQuery(window).width() > 1200) {
          topGutr = 10;
          topGutr = 15;
        } else if (jQuery(window).width() > 1920) {
          topGutr = 20;
        } else {
          topGutr = 0;
        }

        //Calculating the from right position.
        var devwidth = jQuery(window).width();
        var devheight = jQuery(window).height();
        var carwidth = jQuery(".container").width();
        // // var cuepdlft = Math.ceil((devwidth - carwidth) / 2);
        var fnbMenuContainerEle = document.getElementById("fnbMenuContainer");
        if (fnbMenuContainerEle !== null) {
          var fnbMenuContainerEleStyle = fnbMenuContainerEle.currentStyle || window.getComputedStyle(fnbMenuContainerEle);
          var fnbMenuContainerCliWidth = fnbMenuContainerEle.clientWidth;
          var fnbMenuContainerWidth = fnbMenuContainerCliWidth - parseFloat(fnbMenuContainerEleStyle.paddingLeft) - parseFloat(fnbMenuContainerEleStyle.paddingRight);
          // // console.log("fnbMenuContainerWidth: " + fnbMenuContainerWidth);
          var cuepdlft = Math.ceil((devwidth - fnbMenuContainerWidth) / 2);
        } else {
          var cuepdlft = Math.ceil((devwidth - carwidth) / 2);
        }

        //Calculating the container height.
        var ftrHeight = jQuery(".pageFooter").outerHeight(true);
        var btnHeight = jQuery(".pcpCart .pcpcAction").outerHeight(true);
        var cartHeight = devheight - parseInt(hHeight + tHeight + topGutr * 2 + btnHeight + ftrHeight);
        if (jQuery(window).width() > 992 && stopVal > caltrgt) {
          jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright").addClass("sticky");
          jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright .pcpbicrInner").css({
            "padding-top": parseInt(hHeight + tHeight + topGutr + 10),
            right: cuepdlft,
          });
          jQuery(".pcpCart").css("height", cartHeight);

          //Inner Scroll For Items List.
          if (jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").length > 0) {
            var rbsPadtop = parseInt(jQuery(".pcpCart.pcpCartfull .roundBoxshadowed").css("padding-top"));
            var rbsH3hgt = jQuery(".pcpCart.pcpCartfull h3").outerHeight(true);
            var rbsTtlstr = jQuery(".pcpCart .pcpBookingsummary .pcpbsInner .pcpbsTotalstrap").outerHeight(true);
            var savingsHeight =
              jQuery(".pcpCart .pcpBookingsummary .pcpbsInner .pcpbsTotalstrap + .pcpbsContainer").length > 0
                ? jQuery(".pcpCart .pcpBookingsummary .pcpbsInner .pcpbsTotalstrap + .pcpbsContainer").outerHeight(true)
                : 0; //Newly added.

            //var mcsbHeight = parseInt(cartHeight - rbsPadtop * 2 - rbsH3hgt - rbsTtlstr);
            var mcsbHeight = parseInt(cartHeight - rbsPadtop * 2 - rbsH3hgt - rbsTtlstr - savingsHeight - topGutr * 2);
            jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").css("max-height", mcsbHeight);
            // jQuery(
            //   ".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer"
            // ).mCustomScrollbar("update");
          }
        } else {
          jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright").removeClass("sticky");
          jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColright .pcpbicrInner").css({
            "padding-top": "",
            right: "",
          });
          jQuery(".pcpCart").css("height", "");

          //Inner Scroll For Items List.
          // if (jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").length > 0) {
          //   jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").css("max-height", "");
          // }
          if (jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").length > 0) {
            setTimeout(() => {
              var drawerMaxHeight = jQuery(window).height() * 0.9;
              var cartH3Height = jQuery(".pcpCart h3").outerHeight(true);
              var buttonHeight = jQuery(".pcpCart .pcpcAction").outerHeight(true);
              var totalStrapHeight = jQuery(".pcpCart .pcpBookingsummary .pcpbsInner .pcpbsTotalstrap").outerHeight(true);
              // // // // // console.log("drawerMaxHeight: " + drawerMaxHeight);
              // // // // // console.log("cartH3Height: " + cartH3Height);
              // // // // // console.log("buttonHeight: " + buttonHeight);
              // // // // // console.log("totalStrapHeight: " + totalStrapHeight);
              jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").css("max-height", parseInt(drawerMaxHeight - cartH3Height - buttonHeight - totalStrapHeight));
            }, 200);
          }
        }
      }
    });

    //Age Restriction Modal.
    const ageRestrictedEle = document.getElementById("allowAlcoholic");
    ageRestrictionModal = new Modal(ageRestrictedEle);
  }

  componentDidUpdate = (prevProps, prevState) => {
    window.addEventListener("resize", this.handleWindowResize);
     if (!prevState.fnbMenuRedirect && this.state.fnbMenuRedirect) {
    this.setState({ fnbMenuRedirect: false });
  }
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.handleWindowResize);
  };

  handleWindowResize = () => {
    this.setState({windowWidth: window.innerWidth});
  };

  // callEndPoint = (data, endpoint) => {
  //   return new Promise((resolve, reject) => {
  //     var config = {
  //       method: "POST",
  //       url: process.env.REACT_APP_BASEURL + endpoint,
  //       headers: {
  //         Authorization: "Basic " + new Buffer.from(process.env.REACT_APP_USERNAME + ":" + process.env.REACT_APP_PASSWORD).toString("base64"),
  //         "Content-Type": "application/json",
  //       },
  //       data: {...data, app_version: "1.0.0", app_platform: "Website"},
  //     };
  //     axios(config)
  //       .then((response) => {
  //         resolve(response);
  //       })
  //       .catch(async (ex) => {
  //         reject({error: "Error"});
  //       });
  //   });
  // };
  callEndPoint = (data, endpoint, methodType) => {
    var dataObject = {app_version: "1.0.0", app_platform: "Website"};
    if (data.length != 0) {
      dataObject = {...dataObject, ...data};
    }
    return new Promise((resolve, reject) => {
      var config = {
        method: methodType,
        url: process.env.REACT_APP_BASEURL + endpoint,
        headers: {
          Authorization: "Basic " + new Buffer.from(process.env.REACT_APP_USERNAME + ":" + process.env.REACT_APP_PASSWORD).toString("base64"),
          "Content-Type": "application/json",
        },
        data: dataObject,
      };
      axios(config)
        .then((response) => {
          resolve(response);
        })
        .catch(async (ex) => {
          reject({error: "Error"});
        });
    });
  };

  // setyourSelectionBlock = (boolFlag) => {
  //   this.setState({
  //     yourSelectionBlock: boolFlag,
  //   });
  // };

  handleCategoryTabsUiAnimation = () => {
    // // // // // console.log("App > handleCategoryTabsUiAnimation()");
    /* Category List */
    var tabList = jQuery(".pcpFnbblock .pcpfnbCategory ul li:not(.animateLi)");
    var tabContent = jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li");
    // // // // // console.log("tabList: " + tabList.length + " tabContent: " + tabContent.length);
    if (tabList.length > 0 && tabContent.length > 0 && tabList.length == tabContent.length) {
      if (jQuery(".pcpFnbblock .pcpfnbCategory ul li.animateLi").length <= 0) {
        jQuery(".pcpFnbblock .pcpfnbCategory ul").append('<li class="animateLi">&nbsp;</li>');
      }

      var scrollPos = jQuery(window).scrollTop();
      // // // // // var headerHeight = jQuery(".pageHeader").outerHeight(true);
      // // // // // headerHeight = 0; //***Option to remove fixed header.
      var headerHeight = jQuery(".header").outerHeight(true);
      headerHeight = jQuery(window).width() > 1023 ? headerHeight : 0;
      var tabHeight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
      var tcFirstpos = tabContent.eq(0).offset().top;
      var focusStart = parseInt(tcFirstpos - headerHeight - tabHeight);
      if (scrollPos < focusStart) {
        tabList.removeClass("focus");

        jQuery(".pcpFnbblock .pcpfnbCategory ul li:first-child").addClass("focus");
        setTimeout(function () {
          var eleWidth = jQuery(".pcpFnbblock .pcpfnbCategory ul li:first-child a").outerWidth(true);
          var cpliLeft = jQuery(".pcpFnbblock .pcpfnbCategory ul li:first-child").position().left;
          cpliLeft = cpliLeft + parseInt(jQuery(".pcpFnbblock .pcpfnbCategory ul li:first-child").css("padding-left"));
          jQuery(".pcpFnbblock .pcpfnbCategory ul li.animateLi").css({
            width: eleWidth,
            left: cpliLeft,
          });
        }, 400);
      } else {
        jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li").each(function () {
          var curli = jQuery(this);
          var curliId = curli.attr("id");
          var curliTop = curli.offset().top;

          //////////console.log(curliTop);
          // // // // // var hdrHeight = jQuery(".pageHeader").outerHeight(true);
          // // // // // hdrHeight = 0; //***Option to remove fixed header.
          var hdrHeight = jQuery(".header").outerHeight(true);
          hdrHeight = jQuery(window).width() > 1023 ? hdrHeight : 0;
          var tabHeight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
          var curliPos = parseInt(curliTop - hdrHeight - tabHeight - 5);
          //////////console.log(curliPos);

          var curAnchor = jQuery(".pcpFnbblock .pcpfnbCategory ul li a[data-target='#" + curliId + "']");
          var caParentli = curAnchor.parent("li");
          if (curliPos <= scrollPos && parseInt(curliPos + jQuery(this).outerHeight(true)) > scrollPos) {
            setTimeout(function () {
              var caWidth = curAnchor.outerWidth(true);
              var cpliLeft = caParentli.position().left;
              var cpliPleft = parseInt(caParentli.css("padding-left"));
              //////////console.log('Left: '+cpliLeft+" Padding Left: "+cpliPleft);
              cpliLeft = cpliLeft + cpliPleft;
              //////////console.log("Total: "+cpliLeft);
              jQuery(".pcpFnbblock .pcpfnbCategory ul li").removeClass("focus");
              caParentli.addClass("focus");
              jQuery(".pcpFnbblock .pcpfnbCategory ul li.animateLi").css({
                width: caWidth,
                left: cpliLeft,
              });
            }, 400);
            setTimeout(function () {
              //   jQuery(
              //     ".pcpFnbblock .pcpfnbCategory .pcpfnbcInner .mcsbWrapper.mCustomScrollbar"
              //   ).mCustomScrollbar("update");
              //   jQuery(
              //     ".pcpFnbblock .pcpfnbCategory .pcpfnbcInner .mcsbWrapper.mCustomScrollbar"
              //   ).mCustomScrollbar("scrollTo", caParentli);
              jQuery(caParentli)[0].scrollIntoView();
              //}, 500);
            }, 0);
          } else {
            caParentli.removeClass("focus");
          }
        });
      }
    }
  };

  handleOnclickCategoryItem = (e) => {
    ////////console.log("Routing > handleOnclickCategoryItem()");
    var curLi = jQuery(e.target).parent("li");
    var curAn = jQuery(e.target);
    var dtAttr = curAn.attr("data-target");

    if (typeof dtAttr !== typeof undefined && dtAttr !== false && dtAttr != "") {
      if (!curLi.hasClass("active")) {
        /* Active State Update. */
        jQuery(".pcpFnbblock .pcpfnbCategory ul li").removeClass("active");
        curLi.addClass("active");
        var curLileft = curLi.position().left;

        jQuery(curLi)[0].scrollIntoView();

        /* Scrolltop & Toggle */
        jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li").removeClass("active");
        jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li > .pcpfnbiBox .pcpfnbibBody")
          .slideUp(500)
          .promise()
          .always(function () {
            // console.log("Cards Collapsed.");
            // // // // // var headerHeight = jQuery(".pageHeader").outerHeight(true);
            // // // // // headerHeight = 0; //***Option to remove fixed header.
            var headerHeight = jQuery(".header").outerHeight(true);
            headerHeight = jQuery(window).width() > 1023 ? headerHeight : 0;
            var catTabheight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
            var targetPadtop = parseInt(jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + "").css("padding-top"));
            var targetPostop = jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + "").offset().top;
            var gutterSpace = jQuery(window).width() > 992 ? targetPadtop - 20 : 0;
            targetPostop = targetPostop + gutterSpace;
            var caltrgScltop = parseInt(targetPostop - (headerHeight + catTabheight));
            //jQuery("html, body").scrollTop(caltrgScltop);
            jQuery("html, body").animate(
              {
                scrollTop: caltrgScltop,
              },
              () => {
                jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + "").addClass("active");
                setTimeout(() => {
                  jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + " > .pcpfnbiBox .pcpfnbibBody").slideDown(500);
                }, 500);
              }
            );
          });
      } else {
        // // // // // var headerHeight = jQuery(".pageHeader").outerHeight(true);
        // // // // // headerHeight = 0; //***Option to remove fixed header.
        var headerHeight = jQuery(".header").outerHeight(true);
        headerHeight = jQuery(window).width() > 1023 ? headerHeight : 0;
        var catTabheight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
        var targetPadtop = parseInt(jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + "").css("padding-top"));
        var targetPostop = jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + "").offset().top;
        var gutterSpace = jQuery(window).width() > 992 ? targetPadtop - 20 : 0;
        targetPostop = targetPostop + gutterSpace;
        var caltrgScltop = parseInt(targetPostop - (headerHeight + catTabheight));
        //jQuery("html, body").scrollTop(caltrgScltop);
        jQuery("html, body").animate({
          scrollTop: caltrgScltop,
        });
      }
    }
  };
  handleOnclickCategoryItem123456 = (e) => {
    ////////console.log("Routing > handleOnclickCategoryItem()");
    //handleOnclickCategoryItem = (e, osRef) => {
    //////////console.log(e.target);
    //////////console.log(osRef.osInstance());
    //var osInstance = osRef.osInstance();
    var curLi = jQuery(e.target).parent("li");
    var curAn = jQuery(e.target);
    var dtAttr = curAn.attr("data-target");
    //////////console.log("dtAttr: " + dtAttr);
    if (typeof dtAttr !== typeof undefined && dtAttr !== false && dtAttr != "") {
      if (!curLi.hasClass("active")) {
        /* Active State Update. */
        curLi.addClass("active");
        var curLileft = curLi.position().left;
        // jQuery(
        //   ".pcpFnbblock .pcpfnbCategory .pcpfnbcInner .mcsbWrapper"
        // ).mCustomScrollbar("scrollTo", curLileft);

        jQuery(curLi)[0].scrollIntoView();
        // jQuery(".pcpFnbblock .pcpfnbCategory .pcpfnbcInner .mcsbWrapper.oshost")
        //   .stop()
        //   .animate(
        //     {
        //       scrollLeft: curLileft,
        //     },
        //     2000
        //   );
        // setTimeout(() => {
        //   jQuery(
        //     ".pcpFnbblock .pcpfnbCategory .pcpfnbcInner .mcsbWrapper.oshost"
        //   ).scrollLeft(curLileft);
        // }, 0);

        /* Scrolltop & Toggle */
        setTimeout(function () {
          jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + "").addClass("active");
          jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + " > .pcpfnbiBox .pcpfnbibBody").slideDown(500);
          // jQuery(
          //   ".pcpFnbblock .pcpfnbCategorylist > ul > li" +
          //     dtAttr +
          //     " .pcpfnbiBox .pcpfnbibHead"
          // ).removeClass("collapsed");
          // // jQuery(
          // //   ".pcpFnbblock .pcpfnbCategorylist > ul > li" +
          // //     dtAttr +
          // //     " > .pcpfnbiBox .pcpfnbibBody"
          // // ).slideDown(function () {
          // //   // jQuery(
          // //   //   ".pcpFnbblock .pcpfnbCategorylist > ul > li" +
          // //   //     dtAttr +
          // //   //     " .pcpfnbiBox .pcpfnbibBody"
          // //   // ).addClass("show");
          // // });
          // jQuery(
          //   ".pcpFnbblock .pcpfnbCategorylist > ul > li" +
          //     dtAttr +
          //     " .pcpfnbiBox .pcpfnbibBody"
          // ).addClass("show");
        }, 750);
      }

      var headerHeight = jQuery(".pageHeader").outerHeight(true);
      headerHeight = 0; //***Option to remove fixed header.
      var catTabheight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
      var targetPadtop = parseInt(jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + "").css("padding-top"));
      var targetPostop = jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li" + dtAttr + "").offset().top;
      var gutterSpace = jQuery(window).width() > 992 ? targetPadtop - 20 : 0;
      targetPostop = targetPostop + gutterSpace;
      var caltrgScltop = parseInt(targetPostop - (headerHeight + catTabheight));

      // jQuery("html, body").stop().animate({
      //   scrollTop: caltrgScltop,
      // }, 750);
      jQuery("html, body").scrollTop(caltrgScltop);
    }
  };

  handleCategoryThumbOnclick12345 = (e) => {
    ////////console.log("Routing > handleCategoryThumbOnclick()");
    //return false;
    var curAn = jQuery(e.target);
    var curLi = curAn.parents("li");
    //var curAn = jQuery(this);
    var dtAttr = curLi.attr("id");
    var caltrgScltop = "";
    var wnwScrlt = jQuery(window).scrollTop();

    /* Active State Update. */
    jQuery("a[data-target='#" + dtAttr + "']")
      .parent("li")
      .toggleClass("active");
    var curLileft = jQuery("a[data-target='#" + dtAttr + "']")
      .parent("li")
      .position().left;
    // jQuery(
    //   ".pcpFnbblock .pcpfnbCategory .pcpfnbcInner .mcsbWrapper"
    // ).mCustomScrollbar("scrollTo", curLileft);
    jQuery(".pcpFnbblock .pcpfnbCategory ul li a[data-target='#" + dtAttr + "']")
      .parent("li")[0]
      .scrollIntoView();

    /* Scrolltop & Toggle */
    setTimeout(function () {
      var headerHeight = jQuery(".pageHeader").outerHeight(true);
      headerHeight = 0; //***Option to remove fixed header.
      //////////console.log("Header Height: "+headerHeight);
      var catTabheight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
      //////////console.log("Category List(Tab) Height: "+catTabheight);
      var targetPadtop = parseInt(curLi.css("padding-top"));
      //targetPadtop = 0;
      //////////console.log("Target Padding Top: "+targetPadtop);
      var targetPostop = curLi.offset().top;
      var gutterSpace = jQuery(window).width() > 992 ? targetPadtop - 20 : 0;
      targetPostop = targetPostop + gutterSpace;
      //////////console.log("Target Top: "+targetPostop);
      caltrgScltop = parseInt(targetPostop - (headerHeight + catTabheight));
      //////////console.log("Calculated Scroll Top: "+caltrgScltop);

      // jQuery("html, body").stop().animate(
      //   {
      //     scrollTop: caltrgScltop,
      //   },
      //   750
      // );
      jQuery("html, body").scrollTop(caltrgScltop);

      if (caltrgScltop != "" && wnwScrlt == caltrgScltop) {
        //////////console.log("wnwScrlt0:" + wnwScrlt);
        //////////console.log("caltrgScltop0:" + caltrgScltop);
        curLi.toggleClass("active");
        curLi.find("> .pcpfnbiBox .pcpfnbibBody").slideToggle(500);
      }
    }, 500);
    setTimeout(function () {
      if (caltrgScltop == "" || wnwScrlt != caltrgScltop) {
        //////////console.log("wnwScrlt1:" + wnwScrlt);
        //////////console.log("caltrgScltop1:" + caltrgScltop);
        curLi.toggleClass("active");
        curLi.find("> .pcpfnbiBox .pcpfnbibBody").slideToggle(500);
      }
    }, 1250);
  };
  handleCategoryThumbOnclick = (e, menuItem) => {
    try {
      window.Moengage.track_event("FnB Type select", {
        State: this.state.compHomeSelectedOptions.stateFullString,
        "Cinema Location": this.state.compHomeSelectedOptions.cinemaFullString,
        "Order Method": this.state.compHomeSelectedOptions.deliverOption,
        Showdate: this.state.compHomeSelectedOptions.showDate,
        Moviename: this.state.compHomeSelectedOptions.movieFullString,
        Showtime: this.state.compHomeSelectedOptions.showTimeFullString,
        "Seat number": this.state.compHomeSelectedOptions.seatNumber,
        "Delivery Time": this.state.compHomeSelectedOptions.deliverToSeatTimeFullString,
        "FnB type": menuItem.Name,
      });
    } catch (error) {
      console.log(error);
    }
    console.log("Routing > handleCategoryThumbOnclick()");
    var curAn = jQuery(e.target);
    var curLi = curAn.parents("li");
    var dtAttr = curLi.attr("id");
    // var categoryEle = document.querySelectorAll("a[data-target='#" + dtAttr + "']");
    // console.log("categoryEle:");
    // console.log(categoryEle);
    // categoryEle[0].click();
    var caltrgScltop = "";
    var wnwScrlt = jQuery(window).scrollTop();

    if (curLi.hasClass("active")) {
      console.log("if > curLi.hasClass('active')");
      /* Active State Update. */
      // jQuery(".pcpFnbblock .pcpfnbCategory ul li").removeClass("active");
      // jQuery("a[data-target='#" + dtAttr + "']").parent("li").toggleClass("active");
      // jQuery(".pcpFnbblock .pcpfnbCategory ul li a[data-target='#" + dtAttr + "']").parent("li")[0].scrollIntoView();
      jQuery("a[data-target='#" + dtAttr + "']")
        .parent("li")
        .removeClass("active");
      jQuery(".pcpFnbblock .pcpfnbCategory ul li a[data-target='#" + dtAttr + "']")
        .parent("li")[0]
        .scrollIntoView();
      /* Scroll to focus */
      // setTimeout(function () {
      // // // // // var headerHeight = jQuery(".pageHeader").outerHeight(true);
      // // // // // headerHeight = 0; //***Option to remove fixed header.
      var headerHeight = jQuery(".header").outerHeight(true);
      headerHeight = jQuery(window).width() > 1023 ? headerHeight : 0;
      var catTabheight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
      var targetPadtop = parseInt(curLi.css("padding-top"));
      var targetPostop = curLi.offset().top;
      var gutterSpace = jQuery(window).width() > 992 ? targetPadtop - 20 : 0;
      targetPostop = targetPostop + gutterSpace;
      caltrgScltop = parseInt(targetPostop - (headerHeight + catTabheight));
      jQuery("html, body").scrollTop(caltrgScltop);
      if (caltrgScltop != "" && wnwScrlt == caltrgScltop) {
        curLi.toggleClass("active");
        curLi.find("> .pcpfnbiBox .pcpfnbibBody").slideToggle(500);
      }
      // }, 500);
      setTimeout(function () {
        if (caltrgScltop == "" || wnwScrlt != caltrgScltop) {
          curLi.toggleClass("active");
          curLi.find("> .pcpfnbiBox .pcpfnbibBody").slideToggle(500);
        }
        // }, 1250);
      }, 750);
    } else {
      console.log("else > curLi.hasClass('active')");
      var categoryEle = document.querySelectorAll("a[data-target='#" + dtAttr + "']");
      console.log("categoryEle:");
      console.log(categoryEle);
      categoryEle[0].click();
    }

    // // // // // var curAn = jQuery(e.target);
    // // // // // var curLi = curAn.parents("li");
    // // // // // //var curAn = jQuery(this);
    // // // // // var dtAttr = curLi.attr("id");
    // // // // // var caltrgScltop = "";
    // // // // // var wnwScrlt = jQuery(window).scrollTop();

    // // // // // /* Active State Update. */
    // // // // // jQuery(".pcpFnbblock .pcpfnbCategory ul li").removeClass("active");
    // // // // // jQuery("a[data-target='#" + dtAttr + "']")
    // // // // //   .parent("li")
    // // // // //   .toggleClass("active");
    // // // // // jQuery(".pcpFnbblock .pcpfnbCategory ul li a[data-target='#" + dtAttr + "']")
    // // // // //   .parent("li")[0]
    // // // // //   .scrollIntoView();

    // // // // // /* Scrolltop & Toggle */
    // // // // // if(curLi.hasClass("active")) {

    // // // // // } else {

    // // // // // }
    // // // // // setTimeout(function () {
    // // // // //   var headerHeight = jQuery(".pageHeader").outerHeight(true);
    // // // // //   headerHeight = 0; //***Option to remove fixed header.
    // // // // //   var catTabheight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
    // // // // //   var targetPadtop = parseInt(curLi.css("padding-top"));
    // // // // //   var targetPostop = curLi.offset().top;
    // // // // //   var gutterSpace = jQuery(window).width() > 992 ? targetPadtop - 20 : 0;
    // // // // //   targetPostop = targetPostop + gutterSpace;
    // // // // //   caltrgScltop = parseInt(targetPostop - (headerHeight + catTabheight));
    // // // // //   jQuery("html, body").scrollTop(caltrgScltop);
    // // // // //   if (caltrgScltop != "" && wnwScrlt == caltrgScltop) {
    // // // // //     curLi.toggleClass("active");
    // // // // //     curLi.find("> .pcpfnbiBox .pcpfnbibBody").slideToggle(500);
    // // // // //   }
    // // // // // }, 500);
    // // // // // setTimeout(function () {
    // // // // //   if (caltrgScltop == "" || wnwScrlt != caltrgScltop) {
    // // // // //     curLi.toggleClass("active");
    // // // // //     curLi.find("> .pcpfnbiBox .pcpfnbibBody").slideToggle(500);
    // // // // //   }
    // // // // // }, 1250);
  };

  bottomSpacecalculation = () => {
    // // // // // console.log("Routing > bottomSpacecalculation()");
    var wnwHeight = jQuery(window).outerHeight(true);
    // // // // // var hdrHeight = jQuery(".pageHeader").outerHeight(true);
    // // // // // hdrHeight = 0; //***Option to remove fixed header.
    var hdrHeight = jQuery(".header").outerHeight(true);
    hdrHeight = jQuery(window).width() > 1023 ? hdrHeight : 0;
    // var ftrHeight = jQuery(".pageFooter").outerHeight(true);
    var ftrHeight = 0;
    var tabHeight = jQuery(".pcpFnbblock .pcpfnbCategory").outerHeight(true);
    var tbCntlast = jQuery(".pcpFnbblock .pcpfnbCategorylist > ul > li").last();
    var tcnHeight = tbCntlast.find(".pcpfnbiBox .pcpfnbibHead").outerHeight(true);
    tbCntlast.css("margin-bottom", "");
    var bstHeight = jQuery(window).width() < 992 && jQuery(".pcpbBottomstrap").length > 0 ? jQuery(".pcpbBottomstrap").outerHeight(true) : 0;
    // // // // // console.log("bstHeight: " + bstHeight);
    var pb0 = parseInt(tbCntlast.css("padding-top"));
    // var pb1 = parseInt(jQuery(".pcPanel").css("padding-bottom"));
    // var pb2 = parseInt(jQuery(".pcPanel .pcpBody").css("padding-bottom"));
    var pb1 = 0;
    var pb2 = 0;
    var pb3 = parseInt(jQuery(".pcpbInner .pcpbiColswrap .pcpbiCols.pcpbiColleft .pcpbiclInner").css("padding-bottom"));

    var calSpace = parseInt(wnwHeight - (hdrHeight + tabHeight + tcnHeight + ftrHeight + bstHeight + pb0 + pb1 + pb2 + pb3));
    // // // // // console.log("calSpace: " + calSpace);
    if (calSpace >= 0) {
      tbCntlast.css("margin-bottom", calSpace);
    } else {
      tbCntlast.css("margin-bottom", "");
    }
  };

  fnbmodifierBodyheight = () => {
    // // // // // console.log("App > fnbmodifierBodyheight()");
    var fnbModifier = jQuery("#modalFnbModifier");
    // // // // // console.log("fnbModifier.length: " + fnbModifier.length);

    var trgele = fnbModifier.find(".osbWrap");
    // // // // // console.log("trgele.length: " + trgele.length);

    /* Overlay Scrollbar*/
    if (fnbModifier.length > 0 && trgele.length > 0) {
      // // // // // console.log("App > fnbmodifierBodyheight() > fnbModifier.length > 0 && trgele.length > 0");

      //Elements
      var devWidth = jQuery(window).width();
      var devHeight = jQuery(window).height();
      var modalDialog = fnbModifier.find(".modal-dialog");
      var modalContent = fnbModifier.find(".modal-content");
      var modalHeader = fnbModifier.find(".modal-header");

      var modalBody = fnbModifier.find(".osbWrap");
      var modalFooter = fnbModifier.find(".modal-footer");

      // modalBody.css("max-height", "");
      modalBody.css("height", "");
      setTimeout(function () {
        //Elements - Getting Values
        var mdMtop = modalDialog.css("margin-top");
        var mcHeight = modalContent.outerHeight(true);
        var mdmcHeight = parseInt(parseInt(mdMtop) * 2 + mcHeight);
        var mhHeight = modalHeader.outerHeight(true);
        var mhFooter = modalFooter.outerHeight(true);
        var mbCalhgt = parseInt(devHeight * 0.9 - (parseInt(mdMtop) * 2 + mhFooter)); // 0.9(size="90%") height of the drawer.

        if (devHeight >= 480) {
          // modalBody.css("max-height", mbCalhgt);
          modalBody.css("height", mbCalhgt);
        } else {
          // modalBody.css("max-height", "");
          modalBody.css("height", "");
        }
      }, 0);
    }
  };

  setCompHomeSelectedOptions = (selectedOptions) => {
    console.log("setCompHomeSelectedOptions() > selectedOptions!=prevcompHomeSelectedOptions");
    var prevcompHomeSelectedOptions = this.state.compHomeSelectedOptions;
    this.setState(
      {
        compHomeSelectedOptions: selectedOptions,
        fnbMenuRedirect: true,
        alcoholAgeValidation: false,
      },
      () => {
        if (JSON.stringify(selectedOptions) != JSON.stringify(prevcompHomeSelectedOptions)) {
          this.setState({
            cartData: [],
            fnbMenuData: [],
          });
        }
        this.loadStateData();
      }
    );
    // var compHomeSelectedOptions = this.state.compHomeSelectedOptions;
    // if(JSON.stringify(selectedOptions) != JSON.stringify(this.state.compHomeSelectedOptions)) {
    //   this.setState({
    //     cartData: [],
    //     fnbMenuData: [],
    //     compHomeSelectedOptions: selectedOptions,
    //   fnbMenuRedirect: true,
    //   })
    // } else {
    //   this.setState({
    //     compHomeSelectedOptions: selectedOptions,
    //     fnbMenuRedirect: true,
    //   });
    // }
  };

  redirectToSelectionPage = () => {
    localStorage.setItem("redirectedFromMenu", true);
    this.setState({
      selectionPageRedirect: true,
    });
  };
  showModifiersDrawer = async () => {
    //>// console.log("showModifiersDrawer()");
    await this.fnbmodifierBodyheight();
    this.setState(
      {
        modifiersModalDrawer: true,
        //>// upsizeIsUpsize: 0,
        //>// upsizePriceDifferent: 0,
        //>// upsizeFrom: "",
      },
      () => {
        //>// console.log("App.js > this.state.modifiersDrawer: " + this.state.modifiersModalDrawer);
        document.body.className += " modifiersDrawerOpen";
      }
    );
  };

  showUpsizeDrawer = () => {
    this.setState({
      upsizeModalDrawerFlag: true,
      upsizeIsUpsize: 0,
      upsizePriceDifferent: 0,
      //>// upsizeFrom: "",
    });
  };

  hideUpsizeDrawer = async () => {
    await this.setState(
      {
        // fnbItemData: [],
        upsizeModalDrawerFlag: false,
        upsizeProceedFlag: false,
        // upsizeIsUpsize: 0,
        // upsizePriceDifferent: 0,
      },
      () => {
        // Flush data on drawer close.
        // if ((this.state.fnbItemData.length > 0 || Object.keys(this.state.fnbItemData).length > 0) && this.state.fnbItemData.Modfiergroups == "1") {
        //   alert();
        //   this.onCloseflushModifierModalData();
        // }
      }
    );
  };

  upsizeItem = async (upsizeFlag) => {
    var currentfnbItemData = this.state.fnbItemData;
    await this.hideUpsizeDrawer();
    if (upsizeFlag) {
      if (this.state.upsizeProceedFlag == false) {
        this.setState(
          {
            upsizeProceedFlag: true,
            upsizeIsUpsize: currentfnbItemData.Upsize,
            upsizePriceDifferent: currentfnbItemData.UpsizeMenuItems[0].PriceDifferent,
            //>// upsizeFrom: currentfnbItemData.MenuItemId + "_" + currentfnbItemData.Name,
          },
          () => {
            var upsizeTargetEle = document.getElementById("fnbItem_" + currentfnbItemData.UpsizeMenuItems[0].MenuItemId + "");
            var tempCartData = this.state.cartData;
            if (tempCartData.length > 0) {
              tempCartData.map((tcdItem, index) => {
                if (tcdItem.itemInCartFlag == false) {
                  tempCartData.splice(index, 1);
                }
              });
              this.setState(
                {
                  fnbMenuData: tempFnBData,
                  cartData: tempCartData,
                  upsizeProceedFlag: currentfnbItemData.Modfiergroups == "1" ? this.state.upsizeProceedFlag : false,
                  //>// upsizeIsUpsize: currentfnbItemData.Modfiergroups == "1" ? this.state.upsizeIsUpsize : 0,
                  //>// upsizePriceDifferent: currentfnbItemData.Modfiergroups == "1" ? this.state.upsizePriceDifferent : 0,
                  //>// upsizeFrom: currentfnbItemData.Modfiergroups == "1" ? this.state.upsizeFrom : "",
                },
                () => {
                  if (currentfnbItemData.Modfiergroups == "1") {
                    modifierGroupsArray = []; //Flushing global modifierGroupsArray varible.
                  }
                  upsizeTargetEle.click();
                }
              );
            }

            // upsizeTargetEle.click();
          }
        );
      }
    } else {
      console.log("else > upsizeFlag is true");
      if (this.state.upsizeProceedFlag == false) {
        console.log("if > this.state.upsizeProceedFlag == false");
        this.setState(
          {
            upsizeProceedFlag: true,
          },
          () => {
            // this.loadStateData();
            // var currentfnbItemData = this.state.fnbItemData;
            // console.log(currentfnbItemData);
            console.log("currentfnbItemData.MenuItemId: " + currentfnbItemData.MenuItemId);
            var currentItemUniqueId = currentfnbItemData.MenuId + "_" + currentfnbItemData.MenuItemId;
            console.log("currentItemUniqueId: " + currentItemUniqueId);

            var tempCartData = this.state.cartData;
            console.log("tempCartData: ");
            console.log(tempCartData);
            var itemIndex = tempCartData.findIndex((x) => x.itemUniqueIdentifier === currentItemUniqueId);
            console.log("itemIndex: " + itemIndex);

            var lastCartItemData = this.state.cartData[this.state.cartData.length - 1];
            console.log("lastCartItemData.id: " + lastCartItemData.id);

            if (currentfnbItemData.MenuItemId == lastCartItemData.id || itemIndex != -1) {
              console.log("if > currentfnbItemData.MenuItemId == lastCartItemData.id");
              if (currentfnbItemData.Modfiergroups == 0) {
                console.log("if > currentfnbItemData.Modfiergroups==0");
                // var tempCartData = this.state.cartData;
                // console.log("tempCartData: ");
                // console.log(tempCartData);
                // var currentItemUniqueId = currentfnbItemData.MenuId + "_" + currentfnbItemData.MenuItemId;
                // console.log("currentItemUniqueId: " + currentItemUniqueId);
                // var itemIndex = tempCartData.findIndex((x) => x.itemUniqueIdentifier === currentItemUniqueId);
                // if (currentItemUniqueId != -1 && tempCartData[tempCartData.length - 1].itemInCartFlag == false) {
                if (tempCartData[tempCartData.length - 1].itemInCartFlag == false) {
                  //>// stateCartData.push(cartDataObject);
                  tempCartData[tempCartData.length - 1].itemInCartFlag = true;
                  tempCartData[tempCartData.length - 1].quantity = 1;
                } else {
                  tempCartData[itemIndex].quantity = tempCartData[itemIndex].quantity + 1;
                }

                this.setState(
                  {
                    cartData: tempCartData,
                    upsizeProceedFlag: false,
                    upsizeIsUpsize: 0,
                    upsizePriceDifferent: 0,
                    //>// upsizeFrom: "",
                  },
                  () => {
                    this.loadStateData();
                    console.log("setState > fallback > this.state.cartData");
                    console.log(this.state.cartData);
                  }
                );
              } else {
                console.log("else > currentfnbItemData.Modfiergroups==0");
                this.setState(
                  {
                    upsizeProceedFlag: true,
                  },
                  () => {
                    // this.loadStateData();
                    console.log("currentfnbItemData.UpsizeMenuItems[0].MenuItemId: " + currentfnbItemData.MenuItemId);
                    var upsizeTargetEle = document.getElementById("fnbItem_" + currentfnbItemData.MenuItemId + "");
                    console.log("upsizeTargetEle: ");
                    console.log(upsizeTargetEle);
                    // upsizeTargetEle.click();
                    upsizeTargetEle.click();
                  }
                );
              }
            } else {
              console.log("else > currentfnbItemData.MenuItemId == lastCartItemData.id");
            }
          }
        );
      } else {
        console.log("else > this.state.upsizeProceedFlag == false");
      }
    }
    var tempFnBData = JSON.parse(JSON.stringify(this.state.fnbMenuData));
    var categoryIndex = null,
      fnbItemIndex = null;
    tempFnBData.map((itemsInEachCategory, eachCategoryIndex) => {
      var tempIndex = itemsInEachCategory.Items.findIndex((x) => x.MenuItemId === currentfnbItemData.MenuItemId);
      if (tempIndex != -1) {
        categoryIndex = eachCategoryIndex;
        fnbItemIndex = tempIndex;
      }
    });
    tempFnBData[categoryIndex].Items[fnbItemIndex].Upsize = "0";
    this.setState({
      fnbMenuData: tempFnBData,
    });
    // UpsizeMenuItems
    // var currentfnbItemData = this.state.fnbItemData;
    // if (Object.keys(currentfnbItemData).length > 0 || currentfnbItemData.length > 0) {
    //   console.log("Object.keys(currentfnbItemData).length>0 || currentfnbItemData.length>0 > if");
    //   await this.hideUpsizeDrawer();
    //   console.log("currentfnbItemData.UpsizeMenuItems[0].MenuItemId: " + currentfnbItemData.UpsizeMenuItems[0].MenuItemId);
    //   var upsizeTargetEle = document.getElementById("fnbItem_" + currentfnbItemData.UpsizeMenuItems[0].MenuItemId + "");
    //   console.log("upsizeTargetEle.length: " + upsizeTargetEle.length);
    //   upsizeTargetEle.click();
    // } else {
    //   console.log("Object.keys(currentfnbItemData).length>0 || currentfnbItemData.length>0 > else");
    // }

    // var tempCartData = JSON.parse(JSON.stringify(this.state.cartData));
    // console.log(JSON.stringify(tempCartData));
    // console.log(this.state.fnbItemData.Name);
    // console.log(this.state.fnbItemData.Name);
    // tempCartData[tempCartData.length - 1].id = this.state.fnbItemData.UpsizeMenuItems[0].MenuItemId;
    // tempCartData[tempCartData.length - 1].SalesItemId = this.state.fnbItemData.UpsizeMenuItems[0].SalesItemId[0].SalesItemId;
    // tempCartData[tempCartData.length - 1].itemName = this.state.fnbItemData.UpsizeMenuItems[0].Name;
    // tempCartData[tempCartData.length - 1].valuebeforetax = this.state.fnbItemData.UpsizeMenuItems[0].Price;

    // var itemUniqueIdentifier = this.state.fnbItemData.UpsizeMenuItems[0].MenuItemId;
    // if (tempCartData[tempCartData.length - 1].modifierGroups.length != 0) {
    //   var modiferGroupArray = [];
    //   tempCartData[tempCartData.length - 1].modifierGroups[0].map((modifierGroupItem) => {
    //     modifierGroupItem.modifierItems.map((cartItemModifier) => {
    //       modiferGroupArray.push(cartItemModifier.modifierItemId + cartItemModifier.modifierItemQuantity);
    //     });
    //   });
    //   itemUniqueIdentifier += modiferGroupArray.sort().join("");
    // }
    // tempCartData[tempCartData.length - 1].itemUniqueIdentifier = itemUniqueIdentifier;
    // console.log(JSON.stringify(tempCartData));
    // this.setState(
    //   {
    //     cartData: tempCartData,
    //     fnbItemData: [],
    //   },
    //   () => {
    //     this.hideUpsizeDrawer();
    //   }
    // );
  };

  hideModifiersDrawer = () => {
    this.setState(
      {
        modifiersModalDrawer: false,
      },
      () => {
        //>// console.log("App.js > this.state.modifiersDrawer: " + this.state.modifiersModalDrawer);
        document.body.className = document.body.className.replace("modifiersDrawerOpen", "");

        // Flush data on drawer close.
        this.onCloseflushModifierModalData();
        // // // // // // // // // // //Flush data on drawer close.
        // // // // // // // // // // this.setState(
        // // // // // // // // // //   {
        // // // // // // // // // //     fnbItemData: this.state.fnbItemData.Upsize == "1" ? this.state.fnbItemData : [],
        // // // // // // // // // //     fnbItemModifierData: [],
        // // // // // // // // // //     tempModifierModalTotal: 0,
        // // // // // // // // // //     requiredModifierGroupCount: 0,
        // // // // // // // // // //     upsizeProceedFlag: false,
        // // // // // // // // // //   },
        // // // // // // // // // //   () => {
        // // // // // // // // // //     var tempCartData = this.state.cartData;
        // // // // // // // // // //     if (tempCartData.length > 0) {
        // // // // // // // // // //       tempCartData.map((tcdItem, index) => {
        // // // // // // // // // //         if (tcdItem.itemInCartFlag == false) {
        // // // // // // // // // //           tempCartData.splice(index, 1);
        // // // // // // // // // //         }
        // // // // // // // // // //       });
        // // // // // // // // // //       this.setState(
        // // // // // // // // // //         {
        // // // // // // // // // //           cartData: tempCartData,
        // // // // // // // // // //         },
        // // // // // // // // // //         () => {
        // // // // // // // // // //           modifierGroupsArray = []; //Flushing global modifierGroupsArray varible.
        // // // // // // // // // //           //>// smartModifiersArray = []; //Flushing global smartModifiersArray varible.
        // // // // // // // // // //         }
        // // // // // // // // // //       );
        // // // // // // // // // //     }
        // // // // // // // // // //     if (this.state.repeatItemIllChoose) {
        // // // // // // // // // //       this.setState(
        // // // // // // // // // //         {
        // // // // // // // // // //           repeatItemIllChoose: false,
        // // // // // // // // // //         },
        // // // // // // // // // //         () => {
        // // // // // // // // // //           //>// this.cartDrawerToggle();
        // // // // // // // // // //           this.state.windowWidth < 992 && this.cartDrawerToggle();
        // // // // // // // // // //         }
        // // // // // // // // // //       );
        // // // // // // // // // //     }
        // // // // // // // // // //   }
        // // // // // // // // // // );

        // // // // // // // // // // //Form Reset.
        // // // // // // // // // // jQuery(".fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .itemCounter .form-control").val(0);
        // // // // // // // // // // jQuery(".fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .itemCounter.icZero").addClass("iczActive");
        // // // // // // // // // // jQuery(".fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .itemCounter.icZero .icControl.iccDecrement").addClass("disabled");
        // // // // // // // // // // jQuery(".fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .customCheckbox input, .fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .customRadio input").prop("checked", false);
        // // // // // // // // // // var fcEle = document.getElementById("modalFnbModifierQuantity");
        // // // // // // // // // // fcEle.value = 1;
        // // // // // // // // // // var CounterEle = document.getElementById("modalFnbItemQuantity");
        // // // // // // // // // // CounterEle.querySelector(".itemCounter.icLarge .icControl.iccDecrement").classList.add("disabled");
        // // // // // // // // // // //Resetting ItemCounter & Checkbox.
        // // // // // // // // // // jQuery(".fnbmodifierModal .modal-body .fnbmmRowwrap .fnbmmrwRows ul li").each(() => {
        // // // // // // // // // //   //Item Counters
        // // // // // // // // // //   var modifierItemcounters = jQuery(this).find(".itemCounter:not(.icLarge)");
        // // // // // // // // // //   ////console.log("modifierItemcounters.length: " + modifierItemcounters.length);
        // // // // // // // // // //   if (modifierItemcounters.length > 0) {
        // // // // // // // // // //     modifierItemcounters.find("input[type=text]").val(0);
        // // // // // // // // // //     modifierItemcounters.find(".icControl.iccIncrement").removeClass("disabled");
        // // // // // // // // // //   }
        // // // // // // // // // //   //Checkbox
        // // // // // // // // // //   var modifierCheckbox = jQuery(this).find(".customCheckbox");
        // // // // // // // // // //   if (modifierCheckbox.length > 0) {
        // // // // // // // // // //     modifierCheckbox.find("input[type=checkbox]").removeAttr("disabled");
        // // // // // // // // // //   }
        // // // // // // // // // // });
        // // // // // // // // // // // var itemCountersAll = document.querySelectorAll(".fnbmodifierModal .modal-body .fnbmmRowwrap .fnbmmrwRows ul li .itemCounter");
        // // // // // // // // // // // //console.log("itemCountersAll.length: " + itemCountersAll.length);
        // // // // // // // // // // // for (var a = 0; a < itemCountersAll.length; a++) {
        // // // // // // // // // // //   document.querySelector(".fnbmodifierModal .modal-body .fnbmmRowwrap .fnbmmrwRows ul li:nth-child(" + a + ") .itemCounter input[type=text]").value = 0;
        // // // // // // // // // // //   document.querySelector(".fnbmodifierModal .modal-body .fnbmmRowwrap .fnbmmrwRows ul li:nth-child(" + a + ") .itemCounter .icControl.iccIncrement").classList.remove("disabled");
        // // // // // // // // // // //   //a[0].querySelector("input[type=text]").value = 0;
        // // // // // // // // // // //   //a[0].querySelector(".icControl.iccIncrement").classList.remove("disabled");
        // // // // // // // // // // // }
      }
    );
  };

  onCloseflushModifierModalData = () => {
    console.log("onCloseflushModifierModalData()");
    //Flush data on drawer close.
    this.setState(
      {
        //>// fnbItemData: this.state.fnbItemData.Upsize == "1" ? this.state.fnbItemData : [],
        fnbItemData: [],
        fnbItemModifierData: [],
        tempModifierModalTotal: 0,
        requiredModifierGroupCount: 0,
        upsizeProceedFlag: false,
        upsizeIsUpsize: 0,
        upsizePriceDifferent: 0,
        //>// upsizeFrom: "",
      },
      () => {
        var tempCartData = this.state.cartData;
        if (tempCartData.length > 0) {
          tempCartData.map((tcdItem, index) => {
            if (tcdItem.itemInCartFlag == false) {
              tempCartData.splice(index, 1);
            }
          });
          this.setState(
            {
              cartData: tempCartData,
            },
            () => {
              modifierGroupsArray = []; //Flushing global modifierGroupsArray varible.
              //>// smartModifiersArray = []; //Flushing global smartModifiersArray varible.
            }
          );
        }
        if (this.state.repeatItemIllChoose) {
          this.setState(
            {
              repeatItemIllChoose: false,
            },
            () => {
              //>// this.cartDrawerToggle();
              this.state.windowWidth < 992 && this.cartDrawerToggle();
            }
          );
        }
      }
    );

    //Form Reset.
    jQuery(".fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .itemCounter .form-control").val(0);
    jQuery(".fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .itemCounter.icZero").addClass("iczActive");
    jQuery(".fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .itemCounter.icZero .icControl.iccDecrement").addClass("disabled");
    jQuery(".fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .customCheckbox input, .fnbmodifierModal .fnbmmRowwrap .fnbmmrwRows ul li .customRadio input").prop("checked", false);
    var fcEle = document.getElementById("modalFnbModifierQuantity");
    fcEle.value = 1;
    var CounterEle = document.getElementById("modalFnbItemQuantity");
    CounterEle.querySelector(".itemCounter.icLarge .icControl.iccDecrement").classList.add("disabled");
    //Resetting ItemCounter & Checkbox.
    jQuery(".fnbmodifierModal .modal-body .fnbmmRowwrap .fnbmmrwRows ul li").each(() => {
      //Item Counters
      var modifierItemcounters = jQuery(this).find(".itemCounter:not(.icLarge)");
      ////console.log("modifierItemcounters.length: " + modifierItemcounters.length);
      if (modifierItemcounters.length > 0) {
        modifierItemcounters.find("input[type=text]").val(0);
        modifierItemcounters.find(".icControl.iccIncrement").removeClass("disabled");
      }
      //Checkbox
      var modifierCheckbox = jQuery(this).find(".customCheckbox");
      if (modifierCheckbox.length > 0) {
        modifierCheckbox.find("input[type=checkbox]").removeAttr("disabled");
      }
    });
    // var itemCountersAll = document.querySelectorAll(".fnbmodifierModal .modal-body .fnbmmRowwrap .fnbmmrwRows ul li .itemCounter");
    // //console.log("itemCountersAll.length: " + itemCountersAll.length);
    // for (var a = 0; a < itemCountersAll.length; a++) {
    //   document.querySelector(".fnbmodifierModal .modal-body .fnbmmRowwrap .fnbmmrwRows ul li:nth-child(" + a + ") .itemCounter input[type=text]").value = 0;
    //   document.querySelector(".fnbmodifierModal .modal-body .fnbmmRowwrap .fnbmmrwRows ul li:nth-child(" + a + ") .itemCounter .icControl.iccIncrement").classList.remove("disabled");
    //   //a[0].querySelector("input[type=text]").value = 0;
    //   //a[0].querySelector(".icControl.iccIncrement").classList.remove("disabled");
    // }
  };

  setLoaderState = (loaderState) => {
    this.setState({
      showLoader: loaderState,
    });
  };

  loadStateData = () => {
    localStorage.setItem("stateData", JSON.stringify(this.state));
  };

  getAllMenusBySiteIdnew = () => {
    // this.setLoaderState(true);
    var self = this;
    //>// console.log("getAllMenusBySiteIdnew()");
    if (Object.keys(this.state.compHomeSelectedOptions).length > 0) {
      var selectedOptions = this.state.compHomeSelectedOptions;
      var dataObj = {
        // site_id: "1",
        theatre_code: selectedOptions.cinema,
        showtime:
          selectedOptions.deliverOption == "Delivery to your seat" || selectedOptions.deliverOption == "Concession Pickup + Food/Alcohol Delivery"
            ? selectedOptions.deliverToSeatTimeFullString
            : selectedOptions.pickUpTimeFullString,
        // theatre_code: "9999",
        // showtime: "2022-11-25 15:30",
        // app_version: "1.0.0",
        // app_platform: "Website",
      };
      this.callEndPoint(dataObj, "getAllMenusBySiteIdnew", "POST")
        .then(function (response) {
          //>// console.log("getAllMenusBySiteIdnew() > then");
          //>// console.log(response.data);
          var resultData = response.data;
          if (resultData.STATUS) {
            //>// console.log(resultData.DATA.Menus);
            self.setState(
              {
                fnbMenuData: resultData.DATA.Menus,
              },
              () => {
                // self.setLoaderState(false);
                //>// console.log(self.state.fnbMenuData);
                setTimeout(() => {
                  self.handleCategoryTabsUiAnimation();
                }, 1000);
                self.loadStateData();
              }
            );
          }
        })
        .catch(function (error) {
          console.log("getAllMenusBySiteIdnew() > catch");
          console.log(error);
          // self.setLoaderState(false);
        });
    }
  };

  getModifiers = (SalesItemData) => {
    var self = this;
    //>// console.log("getModifiers()");
    //>// console.log("SalesItemData");
    //>// console.log(SalesItemData);
    var dataObj = {
      //sales_item_id: "43034",
      sales_item_id: SalesItemData.SalesItemId,
      // theatre_code: "9999",
      theatre_code: this.state.compHomeSelectedOptions.cinema,
      //>// showtime: "2022-11-25 15:30",
      showtime:
        this.state.compHomeSelectedOptions.deliverOption == "Delivery to your seat" || this.state.compHomeSelectedOptions.deliverOption == "Concession Pickup + Food/Alcohol Delivery"
          ? this.state.compHomeSelectedOptions.deliverToSeatTimeFullString
          : this.state.compHomeSelectedOptions.pickUpTimeFullString,
      // app_version: "1.0.0",
      // app_plateform: "Website",
    };
    this.callEndPoint(dataObj, "getModifiers", "POST")
      .then(function (response) {
        //>// console.log("getModifiers() > then");
        //>// console.log(response.data);
        if (response.data.STATUS) {
          var resultData = response.data.DATA.Modifiergroups;
          //>// console.log(resultData);
          self.setState(
            {
              fnbItemModifierData: resultData,
              requiredModifierGroupCount: 0,
            },
            () => {
              // self.setLoaderState(false);
              //>// console.log("self.state.fnbItemModifierData: ");
              //>// console.log(self.state.fnbItemModifierData);
              // setTimeout(() => {
              //   self.handleCategoryTabsUiAnimation();
              // }, 1000);

              var requiredModifierGroup = false;
              console.log("getModifiers() > this.state.requiredModifierGroupCount 0: " + self.state.requiredModifierGroupCount);
              var tempRequiredModifierGroupCount = self.state.requiredModifierGroupCount;
              tempRequiredModifierGroupCount = 0; // Resetting the value, issue while UpSize.
              self.state.fnbItemModifierData.map((mgItem) => {
                if (mgItem.MinimumItems >= 1 && mgItem.MaximumItems >= 1 && (mgItem.MinimumItems == mgItem.MaximumItems || mgItem.MaximumItems > mgItem.MinimumItems)) {
                  requiredModifierGroup = true;
                  tempRequiredModifierGroupCount += 1;
                }
              });
              if (requiredModifierGroup) {
                document.getElementById("modifierModalBtn").classList.add("disabled");
              } else {
                document.getElementById("modifierModalBtn").classList.remove("disabled");
              }
              if (tempRequiredModifierGroupCount >= 0) {
                self.setState(
                  {
                    requiredModifierGroupCount: tempRequiredModifierGroupCount,
                  },
                  () => {
                    console.log("getModifiers() > this.state.requiredModifierGroupCount 1: " + self.state.requiredModifierGroupCount);
                  }
                );
              }
            }
          );
        }
      })
      .catch(function (error) {
        console.log("getModifiers() > catch");
        console.log(error);
        // self.setLoaderState(false);
      });
  };

  // // // // // setFnbItemModifierData = (fnbItemData, tabId, tabName, dealsFlag, ageRestrictionFlag) => {
  setFnbItemModifierData = async (menuItem, ItemData) => {
    // console.log(ItemData, 'ItemData');
    if (ItemData.Alcoholdetails && ItemData.Alcoholdetails.length > 0 && ItemData.Alcoholdetails[0].Alcohol_view == "1") {
      return false;
    }
    try {
      window.Moengage.track_event("FnB item select", {
        State: this.state.compHomeSelectedOptions.stateFullString,
        "Cinema Location": this.state.compHomeSelectedOptions.cinemaFullString,
        "Order Method": this.state.compHomeSelectedOptions.deliverOption,
        Showdate: this.state.compHomeSelectedOptions.showDate,
        Moviename: this.state.compHomeSelectedOptions.movieFullString,
        Showtime: this.state.compHomeSelectedOptions.showTimeFullString,
        "Seat number": this.state.compHomeSelectedOptions.seatNumber,
        "Delivery Time": this.state.compHomeSelectedOptions.deliverToSeatTimeFullString,
        "FnB type": menuItem.Name,
        "FnB Item selected": ItemData.Name,
      });
      this.setState({
        menuItemSelected: menuItem,
      });
    } catch (error) {
      console.log(error);
    }
    console.log("setFnbItemModifierDatasetFnbItemModifierDatasetFnbItemModifierData ------->>>>");
    //>// console.log("setFnbItemModifierData() > menuItem(Category Info): ");
    //>// console.log(menuItem);
    //>// console.log("setFnbItemModifierData() > ItemData(Item Info): ");
    //>// console.log(ItemData);

    // console.log("setFnbItemModifierData() > ageRestrictionFlag: " + ageRestrictionFlag);
    // // // // // if (document.getElementById("button-" + fnbItemData.id) != null && document.getElementById("button-" + fnbItemData.id).classList[2] === "clicked1") {
    if (
      document.getElementById("button-" + menuItem.MenuId + "_" + ItemData.MenuItemId) != null &&
      document.getElementById("button-" + menuItem.MenuId + "_" + ItemData.MenuItemId).classList[2] === "clicked1"
    ) {
      return;
    }

    // Alchocol itmes
    if (ItemData.Alcoholdetails && ItemData.Alcoholdetails.length > 0 && ItemData.Alcoholdetails[0].Alcohol_view == "2" && this.state.alcoholAgeValidation == false) {
      console.log(ItemData, "Alchocol");
      this.setState(
        {
          alcholBeverageCheckFNBData: {
            ItemData,
            MenuId: menuItem.MenuId,
          },
          alchocolDetailsData: ItemData.Alcoholdetails[0],
          alcoholDisableBtn: false,
        },
        () => {
          ageRestrictionModal.show();
        }
      );
      return false;
    }

    //Adding a deal item from common listing.
    // // // // // var dealsData = this.state.deals;
    // // // // // var dealItemIndex = dealsData.findIndex((x) => x.id == fnbItemData.id);
    // // // // // if (dealItemIndex != -1) {
    // // // // //   dealsFlag = true;
    // // // // //   fnbItemData = dealsData[dealItemIndex];
    // // // // // }

    // // // // // if (ageRestrictionFlag == true && this.state.ageRestrictionValidationDone == false) {
    // // // // //   this.setState({
    // // // // //     alcholBeverageCheckFNBData: {
    // // // // //       fnbItemData,
    // // // // //       tabId,
    // // // // //       tabName,
    // // // // //       dealsFlag,
    // // // // //     },
    // // // // //   });
    // // // // //   var tempCartdata = this.state.cartData;
    // // // // //   //Getting the timezone.
    // // // // //   const params = new Proxy(new URLSearchParams(window.location.search), {
    // // // // //     get: (searchParams, prop) => searchParams.get(prop),
    // // // // //   });
    // // // // //   if (tempCartdata.length > 0) {
    // // // // //     var ageRestrictionCount = 0;
    // // // // //     tempCartdata.map((tcdItem) => {
    // // // // //       if (tcdItem.ageRestriction) {
    // // // // //         ageRestrictionCount = ageRestrictionCount + 1;
    // // // // //       }
    // // // // //     });
    // // // // //     if (ageRestrictionCount == 0) {
    // // // // //       var bookingTz = "";
    // // // // //       if (params.bookingid != null && params.cinemaid != null && Object.keys(this.state.bookingInfo).length !== 0) {
    // // // // //         bookingTz = this.state.bookingInfo.tz;
    // // // // //         //////console.log("tempCartdata.length>0 > bookingTz: " + bookingTz);
    // // // // //       } else if (Object.keys(this.state.bookingLocation).length !== 0) {
    // // // // //         bookingTz = this.state.bookingLocation.tz;
    // // // // //       }
    // // // // //       API.callEndpoint("POST", "Bearer", "cms/v1/currenttime", {tz: bookingTz})
    // // // // //         .then((response) => {
    // // // // //           this.setState({
    // // // // //             ageRestrictioncurrenttime: response.data.currenttime,
    // // // // //           });
    // // // // //         })
    // // // // //         .catch((error) => {
    // // // // //           //////console.log("Error: setFnbItemModifierData() > Age Restriction Calculation.");
    // // // // //           //////console.log(error);
    // // // // //         });
    // // // // //       ageRestrictionModal.show();
    // // // // //     }
    // // // // //   } else {
    // // // // //     var bookingTz = "";
    // // // // //     if (params.bookingid != null && params.cinemaid != null && Object.keys(this.state.bookingInfo).length !== 0) {
    // // // // //       bookingTz = this.state.bookingInfo.tz;
    // // // // //       //////console.log("tempCartdata.length>0 > bookingTz: " + bookingTz);
    // // // // //     } else if (Object.keys(this.state.bookingLocation).length !== 0) {
    // // // // //       bookingTz = this.state.bookingLocation.tz;
    // // // // //     }
    // // // // //     API.callEndpoint("POST", "Bearer", "cms/v1/currenttime", {tz: bookingTz})
    // // // // //       .then((response) => {
    // // // // //         ////console.log("response.data.currenttime: " + response.data.currenttime);
    // // // // //         this.setState({
    // // // // //           ageRestrictioncurrenttime: response.data.currenttime,
    // // // // //         });
    // // // // //       })
    // // // // //       .catch((error) => {
    // // // // //         //////console.log("Error: setFnbItemModifierData() > Age Restriction Calculation.");
    // // // // //         //////console.log(error);
    // // // // //       });
    // // // // //     ageRestrictionModal.show();
    // // // // //   }
    // // // // //   return false;
    // // // // // }

    //var stateCartData = this.state.cartData;
    var stateCartData = this.state.cartData.length == 0 ? [] : this.state.cartData;
    // // // // // if ((fnbItemData.fnbs_alternateitems && fnbItemData.fnbs_alternateitems.length == 0) || typeof fnbItemData.fnbs_alternateitems === "undefined") {
    if ((menuItem.fnbs_alternateitems && menuItem.fnbs_alternateitems.length == 0) || typeof menuItem.fnbs_alternateitems === "undefined") {
      //console.log(">>>>> +++++ <<<<<");
      var cartDataObject = new Object();
      // // // // // cartDataObject.tabId = tabId;
      cartDataObject.tabId = menuItem.MenuId; // Category ID(MenuId)
      // // // // // cartDataObject.tabName = tabName;
      cartDataObject.tabName = menuItem.Name; // Category Name(Name)

      // if (fnbItemData.fnbs_alternateitems.length == 0 && fnbItemData.modifierGroups.length == 0 && fnbItemData.smartModifiers.length == 0) {
      // // // // // if (fnbItemData.fnbs_alternateitems && fnbItemData.fnbs_alternateitems.length == 0 && fnbItemData.modifierGroups.length == 0 && fnbItemData.smartModifiers.length == 0) {
      if (parseInt(ItemData.Modfiergroups) == 0) {
        //console.log(">>>>> inside if <<<<<");
        //>// cartDataObject.itemInCartFlag = true;
        cartDataObject.itemInCartFlag = ItemData.Upsize == 1 ? false : true;
        // // // // // cartDataObject.itemUniqueIdentifier = fnbItemData.id;
        cartDataObject.itemUniqueIdentifier = menuItem.MenuId + "_" + ItemData.MenuItemId; // Category ID(MenuId)_Menu Item Id(MenuItemId)
        // // // // // document.getElementById("button-" + fnbItemData.id).classList.add("clicked1");
        document.getElementById("button-" + menuItem.MenuId + "_" + ItemData.MenuItemId).classList.add("clicked1");
        setTimeout(() => {
          // // // // // document.getElementById("button-" + fnbItemData.id).classList.remove("clicked1");
          document.getElementById("button-" + menuItem.MenuId + "_" + ItemData.MenuItemId).classList.remove("clicked1");
        }, 1500);
      } else {
        //console.log(">>>>> inside else <<<<<");
        cartDataObject.itemInCartFlag = false;
        if (ItemData.SalesItemId.length > 1) {
          this.setState({
            salesItemModalDrawer: true,
          });
        } else {
          await this.getModifiers(ItemData.SalesItemId[0]);
        }
      }

      cartDataObject.id = ItemData.MenuItemId; // Menu Item Id(MenuItemId)

      if (ItemData.SalesItemId.length > 1) {
        cartDataObject.SalesItemId = "";
      } else {
        cartDataObject.SalesItemId = ItemData.SalesItemId[0].SalesItemId; // Menu Item > SalesItemId > SalesItemId[0].SalesItemId(SalesItemId)
        cartDataObject.salesItemIdPOSItemId = ItemData.SalesItemId[0].POSItemId;
        cartDataObject.salesItemIdPrice = ItemData.SalesItemId[0].Price;
      }

      cartDataObject.itemName = ItemData.Name; // Menu Item Name(Name)
      cartDataObject.valuebeforetax = ItemData.Price; // Menu Item Price(Price)
      cartDataObject.taxValue = 0;
      cartDataObject.strikeprice = -1;
      //if (fnbItemData.strikeprice != -1) {
      cartDataObject.strikeValueBeforeTax = 0;
      cartDataObject.strikeTaxValue = 0;
      //}
      //>// cartDataObject.quantity = 1;
      cartDataObject.quantity = ItemData.Upsize == 1 && this.state.upsizeProceedFlag == false ? 0 : 1;
      cartDataObject.Upsize = this.state.upsizeIsUpsize;
      cartDataObject.PriceDifferent = this.state.upsizePriceDifferent;
      //>// cartDataObject.upsizeFrom = this.state.upsizeFrom;
      // // // // // if (typeof fnbItemData.fnbs_alternateitems === "undefined") {
      // // // // //   var alternateItemIndex = null;
      // // // // //   var inSeatDelivery = "";
      // // // // //   var pickupAtCounter = "";
      // // // // //   var tempAgeRestriction = "";
      // // // // //   this.state.fnbMenuItems.map((menuItem) => {
      // // // // //     menuItem.fnbtabs_items.map((fnbItem) => {
      // // // // //       if (fnbItem.fnbs_alternateitems.length > 0) {
      // // // // //         alternateItemIndex = fnbItem.fnbs_alternateitems.findIndex((x) => x.id == fnbItemData.id);
      // // // // //         if (alternateItemIndex != null && alternateItemIndex != -1) {
      // // // // //           inSeatDelivery = fnbItem.inSeatDelivery;
      // // // // //           pickupAtCounter = fnbItem.pickupAtCounter;
      // // // // //           tempAgeRestriction = fnbItem.ageRestriction;
      // // // // //         }
      // // // // //       }
      // // // // //     });
      // // // // //   });
      // // // // //   cartDataObject.pickupAtCounter = pickupAtCounter;
      // // // // //   cartDataObject.inSeatDelivery = inSeatDelivery;
      // // // // //   cartDataObject.ageRestriction = tempAgeRestriction;
      // // // // // } else {
      // // // // //   cartDataObject.pickupAtCounter = fnbItemData.pickupAtCounter;
      // // // // //   cartDataObject.inSeatDelivery = fnbItemData.inSeatDelivery;
      // // // // //   cartDataObject.ageRestriction = fnbItemData.ageRestriction;
      // // // // // }

      //cartDataObject.isAlternateitem = {};
      cartDataObject.modifierGroups = [];
      // // // // // cartDataObject.smartModifiers = [];
      // // // // // cartDataObject.dealItem = dealsFlag;
      //cartDataObject.ageRestriction = fnbItemData.ageRestriction;
      cartDataObject.specialinstructions = "";

      // Alcohol Item - true/false
      if (ItemData.Alcoholdetails && ItemData.Alcoholdetails.length > 0 && ItemData.Alcoholdetails[0].Alcohol_view == "2") {
        cartDataObject.IsAlcohol = true;
      } else {
        cartDataObject.IsAlcohol = false;
      }

      var index = stateCartData.findIndex((x) => x.itemUniqueIdentifier === cartDataObject.itemUniqueIdentifier);
      if (index == -1) {
        stateCartData.push(cartDataObject);
      } else {
        //>// stateCartData[index].quantity = stateCartData[index].quantity + 1;
        // Upsize
        if (ItemData.Upsize == 0) {
          stateCartData[index].quantity = stateCartData[index].quantity + 1;
        }
      }
    }

    this.setState(
      {
        // // // // // fnbItemModifierData:
        // // // // //   this.state.fnbItemModifierData == ""
        // // // // //     ? fnbItemData
        // // // // //     : (fnbItemData.fnbs_alternateitems && fnbItemData.fnbs_alternateitems.length == 0) ||
        // // // // //       (fnbItemData.fnbs_alternateitems && fnbItemData.fnbs_alternateitems.length > 0 && fnbItemData.id != this.state.fnbItemModifierData.id)
        // // // // //     ? fnbItemData
        // // // // //     : {...this.state.fnbItemModifierData, modifierGroups: fnbItemData.modifierGroups},
        fnbItemData: {...ItemData, MenuId: menuItem.MenuId},
        cartData: stateCartData,
        repeatItemIndex: false,
        upsizeIsUpsize: 0,
        upsizePriceDifferent: 0,
        salesItemsData: {},
        //>// upsizeFrom: ""
      },
      () => {
        // if (this.state.fnbItemData.Upsize == "1" && parseInt(ItemData.Modfiergroups) == 0) {
        //   this.showUpsizeDrawer();
        // }
        if (this.state.fnbItemData.Upsize == "1" && this.state.upsizeProceedFlag == false) {
          this.setState(
            {
              upsizeProceedFlag: true,
            },
            () => {
              this.showUpsizeDrawer();
            }
          );
        }
        // // // // // if (((fnbItemData.fnbs_alternateitems && fnbItemData.fnbs_alternateitems.length == 0) || fnbItemData.fnbs_alternateitems == "undefined") && cartDataObject.itemInCartFlag) {
        //>// if (((menuItem.fnbs_alternateitems && menuItem.fnbs_alternateitems.length == 0) || menuItem.fnbs_alternateitems == "undefined") && cartDataObject.itemInCartFlag) {
        if (cartDataObject.itemInCartFlag) {
          this.loadStateData();
        }
        //if (fnbItemData.fnbs_alternateitems.length != 0 || fnbItemData.modifierGroups.length != 0 || fnbItemData.smartModifiers.length != 0) {
        // // // // // if ((fnbItemData.fnbs_alternateitems && fnbItemData.fnbs_alternateitems.length != 0) || fnbItemData.modifierGroups.length != 0 || fnbItemData.smartModifiers.length != 0) {
        //>//>// if (ItemData.Modfiergroups == "1" && this.state.fnbItemData.Upsize == "0") {
        if (ItemData.Modfiergroups == "1" && (this.state.fnbItemData.Upsize == "0" || this.state.upsizeProceedFlag)) {
          // alert("setfnbmodifier");
          var requiredModifierGroup = false;

          // // // // // fnbItemData.modifierGroups.map((mgItem) => {
          // // // // // this.state.fnbItemModifierData.Modifiergroups.map((mgItem) => {
          // // // // //   if (mgItem.MinimumItems >= 1 && mgItem.MaximumItems >= 1 && (mgItem.MinimumItems == mgItem.MaximumItems || mgItem.MaximumItems > mgItem.MinimumItems)) {
          // // // // //     requiredModifierGroup = true;
          // // // // //   }
          // // // // // });

          //AlternateItems.
          // // // // // if (fnbItemData.fnbs_alternateitems && fnbItemData.fnbs_alternateitems.length > 0) {
          if (menuItem.fnbs_alternateitems && menuItem.fnbs_alternateitems.length > 0) {
            requiredModifierGroup = true;
            document.getElementById("modiferModalIncrementBtn").classList.add("disabled");
          } else {
            document.getElementById("modiferModalIncrementBtn").classList.remove("disabled");
          }

          // // // // // if (requiredModifierGroup) {
          // // // // //   document.getElementById("modifierModalBtn").classList.add("disabled");
          // // // // // } else {
          // // // // //   document.getElementById("modifierModalBtn").classList.remove("disabled");
          // // // // // }
          //modifierModal.show();
          if (this.state.repeatItemIllChoose) {
            this.closeRepeatItemDrawer();
            //>// this.cartDrawerToggle();
            this.state.windowWidth < 992 && this.cartDrawerToggle();
          }
          if (ItemData.SalesItemId.length == 1) {
            this.showModifiersDrawer();
          }
        }
      }
    );
  };

  modifierItemCounter = (
    event,
    counterFlag,
    itemId,
    modifierGroupId,
    modifierTabid,
    modifierGroupMinQty,
    modifierGroupMaxQty,
    modifierItemId,
    modifierItemName,
    modifierItemAmount,
    modifierItemTax,
    modifierItemStrikeprice,
    modifierItemStrikeValueBeforeTax,
    modifierItemStrikeTaxValue
  ) => {
    //>// console.log("Routing > modifierItemCounter():");
    //counterFlag  > countIncrement | countDecrement
    var curObj = jQuery(event.target);
    var parentObj = curObj.parents(".itemCounter");
    var counterQuantity = parseInt(parentObj.find("input[type=text][readonly]").val());
    if (counterFlag == "countIncrement") {
      counterQuantity = counterQuantity + 1;
      if (counterQuantity > 0 && parentObj.hasClass("iczActive")) {
        parentObj.removeClass("iczActive");
        parentObj.find(".icControl.iccDecrement").removeClass("disabled");
      }
    } else {
      counterQuantity = counterQuantity > 0 ? counterQuantity - 1 : 0;
      if (counterQuantity <= 0 && !parentObj.hasClass("iczActive")) {
        parentObj.addClass("iczActive");
        parentObj.find(".icControl.iccDecrement").addClass("disabled");
      }
    }
    parentObj.find("input[type=text][readonly]").val(counterQuantity);

    /**variable "modifierGroupsArray" ==> Declared global.**/
    var modifierGroupIndex = modifierGroupsArray.findIndex((x) => x.modifierGroupId == modifierGroupId);
    //////////console.log("modifierGroupIndex: " + modifierGroupIndex);
    var modifierGroupsObj = new Object();
    var modifierItemsObj = new Object();
    // modifierGroupsObj.modifierGroupId = modifierGroupId;
    // modifierGroupsObj.modifierItems = [];
    if (modifierGroupIndex != -1) {
      var modifierItemIndex = modifierGroupsArray[modifierGroupIndex].modifierItems.findIndex((x) => x.modifierItemId == modifierItemId);
      if (modifierItemIndex != -1) {
        if (counterQuantity == 0) {
          modifierGroupsArray[modifierGroupIndex].modifierItems.splice(modifierItemIndex, 1);
          if (modifierGroupsArray[modifierGroupIndex].modifierItems.length == 0) {
            modifierGroupsArray.splice(modifierGroupIndex, 1);
          }
        } else {
          modifierGroupsArray[modifierGroupIndex].modifierItems[modifierItemIndex].modifierItemQuantity = counterQuantity;
        }
      } else {
        modifierGroupsObj.modifierItems = [];
        modifierItemsObj.modifierTabid = modifierTabid;
        modifierItemsObj.modifierItemId = modifierItemId;
        modifierItemsObj.modifierItemName = modifierItemName;
        modifierItemsObj.modifierItemAmount = modifierItemAmount;
        modifierItemsObj.modifierItemTax = modifierItemTax;
        modifierItemsObj.modifierItemStrikeprice = modifierItemStrikeprice;
        modifierItemsObj.modifierItemStrikeValueBeforeTax = modifierItemStrikeValueBeforeTax;
        modifierItemsObj.modifierItemStrikeTaxValue = modifierItemStrikeTaxValue;
        modifierItemsObj.modifierItemQuantity = counterQuantity;
        modifierGroupsArray[modifierGroupIndex].modifierItems.push(modifierItemsObj);
      }
    } else {
      modifierGroupsObj.modifierGroupId = modifierGroupId;
      modifierGroupsObj.modifierItems = [];
      modifierItemsObj.modifierTabid = modifierTabid;
      modifierItemsObj.modifierItemId = modifierItemId;
      modifierItemsObj.modifierItemName = modifierItemName;
      modifierItemsObj.modifierItemAmount = modifierItemAmount;
      modifierItemsObj.modifierItemTax = modifierItemTax;
      modifierItemsObj.modifierItemStrikeprice = modifierItemStrikeprice;
      modifierItemsObj.modifierItemStrikeValueBeforeTax = modifierItemStrikeValueBeforeTax;
      modifierItemsObj.modifierItemStrikeTaxValue = modifierItemStrikeTaxValue;
      modifierItemsObj.modifierItemQuantity = counterQuantity;
      modifierGroupsObj.modifierItems.push(modifierItemsObj);
      modifierGroupsArray.push(modifierGroupsObj);
    }

    //Push Modifier Group Data to this.state.cartData.
    var tempCartData = this.state.cartData;
    tempCartData[tempCartData.length - 1].modifierGroups = [];
    if (modifierGroupsArray.length > 0) {
      tempCartData[tempCartData.length - 1].modifierGroups.push(modifierGroupsArray);
    }
    //////////console.log("tempCartData: ");
    //////////console.log(tempCartData);
    this.setState(
      {
        cartData: tempCartData,
      },
      () => {
        //////////console.log("Cart Data After Modifier Groups Added.");
        //////////console.log(this.state.cartData);
        //Validate Modifier Group min/max Quantity.
        //>// this.validateModifierMinMaxQty(itemId, modifierGroupId, modifierGroupMinQty, modifierGroupMaxQty);
        this.validateModifierMinMaxQty(itemId, modifierGroupId, modifierItemId, modifierGroupMinQty, modifierGroupMaxQty);
        //Update Total.
        this.handleCalculateMenuItemTotal(itemId);
      }
    );
  };

  modifierItemCheckboxOnchange = (
    event,
    itemId,
    modifierGroupId,
    modifierTabid,
    modifierGroupMinQty,
    modifierGroupMaxQty,
    modifierItemId,
    modifierItemName,
    modifierItemAmount,
    modifierItemTax,
    modifierItemStrikeprice,
    modifierItemStrikeValueBeforeTax,
    modifierItemStrikeTaxValue
  ) => {
    //>// console.log("Routing > modifierItemCheckboxOnchange()");
    //checkedFlag  > true | false
    var checkedFlag = event.target.checked;
    //>// console.log("checkedFlag: " + checkedFlag);

    /**variable "modifierGroupsArray" ==> Declared global.**/
    var modifierGroupIndex = modifierGroupsArray.findIndex((x) => x.modifierGroupId == modifierGroupId);

    var modifierGroupsObj = new Object();
    var modifierItemsObj = new Object();
    //if (modifierGroupIndex != -1 && checkedFlag == false) {
    if (modifierGroupIndex != -1) {
      var modifierItemIndex = modifierGroupsArray[modifierGroupIndex].modifierItems.findIndex((x) => x.modifierItemId == modifierItemId);
      if (modifierItemIndex != -1) {
        if (checkedFlag == false) {
          modifierGroupsArray[modifierGroupIndex].modifierItems.splice(modifierItemIndex, 1);
          if (modifierGroupsArray[modifierGroupIndex].modifierItems.length <= 0) {
            modifierGroupsArray.splice(modifierGroupIndex, 1);
          }
        }
      } else {
        modifierGroupsObj.modifierItems = [];
        modifierItemsObj.modifierTabid = modifierTabid;
        modifierItemsObj.modifierItemId = modifierItemId;
        modifierItemsObj.modifierItemName = modifierItemName;
        modifierItemsObj.modifierItemAmount = modifierItemAmount;
        modifierItemsObj.modifierItemTax = modifierItemTax;
        modifierItemsObj.modifierItemStrikeprice = modifierItemStrikeprice;
        modifierItemsObj.modifierItemStrikeValueBeforeTax = modifierItemStrikeValueBeforeTax;
        modifierItemsObj.modifierItemStrikeTaxValue = modifierItemStrikeTaxValue;
        modifierItemsObj.modifierItemQuantity = 1;
        modifierGroupsArray[modifierGroupIndex].modifierItems.push(modifierItemsObj);
      }
    } else {
      modifierGroupsObj.modifierGroupId = modifierGroupId;
      modifierGroupsObj.modifierItems = [];
      modifierItemsObj.modifierTabid = modifierTabid;
      modifierItemsObj.modifierItemId = modifierItemId;
      modifierItemsObj.modifierItemName = modifierItemName;
      modifierItemsObj.modifierItemAmount = modifierItemAmount;
      modifierItemsObj.modifierItemTax = modifierItemTax;
      modifierItemsObj.modifierItemStrikeprice = modifierItemStrikeprice;
      modifierItemsObj.modifierItemStrikeValueBeforeTax = modifierItemStrikeValueBeforeTax;
      modifierItemsObj.modifierItemStrikeTaxValue = modifierItemStrikeTaxValue;
      modifierItemsObj.modifierItemQuantity = 1;
      modifierGroupsObj.modifierItems.push(modifierItemsObj);
      modifierGroupsArray.push(modifierGroupsObj);
    }

    //Push Modifier Group Data to this.state.cartData.
    var tempCartData = this.state.cartData;
    tempCartData[tempCartData.length - 1].modifierGroups = [];
    if (modifierGroupsArray.length > 0) {
      tempCartData[tempCartData.length - 1].modifierGroups.push(modifierGroupsArray);
    }
    this.setState(
      {
        cartData: tempCartData,
      },
      () => {
        //Validate Modifier Group min/max Quantity.
        //>// this.validateModifierMinMaxQty(itemId, modifierGroupId, modifierGroupMinQty, modifierGroupMaxQty);
        this.validateModifierMinMaxQty(itemId, modifierGroupId, modifierItemId, modifierGroupMinQty, modifierGroupMaxQty);
        //Update Total.
        this.handleCalculateMenuItemTotal(itemId);
      }
    );
  };

  modifierItemRadioOnchange = (
    event,
    itemId,
    modifierGroupId,
    modifierTabid,
    modifierGroupMinQty,
    modifierGroupMaxQty,
    modifierItemId,
    modifierItemName,
    modifierItemAmount,
    modifierItemTax,
    modifierItemStrikeprice,
    modifierItemStrikeValueBeforeTax,
    modifierItemStrikeTaxValue
  ) => {
    ////////console.log("Routing > modifierItemRadioOnchange()");
    //checkedFlag  > true | false
    var checkedFlag = event.target.checked;

    /**variable "modifierGroupsArray" ==> Declared global.**/
    var modifierGroupIndex = modifierGroupsArray.findIndex((x) => x.modifierGroupId == modifierGroupId);
    //>// console.log("modifierItemRadioOnchange > modifierGroupIndex: " + modifierGroupIndex);

    var modifierGroupsObj = new Object();
    var modifierItemsObj = new Object();
    if (modifierGroupIndex != -1) {
      var modifierItemIndex = modifierGroupsArray[modifierGroupIndex].modifierItems.findIndex((x) => x.modifierItemId == modifierItemId);
      //>// console.log("modifierItemRadioOnchange > modifierItemIndex: " + modifierItemIndex);
      if (modifierItemIndex != -1) {
        //No action.
        // if (checkedFlag == false) {
        //   modifierGroupsArray[modifierGroupIndex].modifierItems.splice(modifierItemIndex, 1);
        //   if (modifierGroupsArray[modifierGroupIndex].modifierItems.length <= 0) {
        //     modifierGroupsArray.splice(modifierGroupIndex, 1);
        //   }
        // }
      } else {
        modifierGroupsObj.modifierItems = [];
        modifierItemsObj.modifierTabid = modifierTabid;
        modifierItemsObj.modifierItemId = modifierItemId;
        modifierItemsObj.modifierItemName = modifierItemName;
        modifierItemsObj.modifierItemAmount = modifierItemAmount;
        modifierItemsObj.modifierItemTax = modifierItemTax;
        modifierItemsObj.modifierItemStrikeprice = modifierItemStrikeprice;
        modifierItemsObj.modifierItemStrikeValueBeforeTax = modifierItemStrikeValueBeforeTax;
        modifierItemsObj.modifierItemStrikeTaxValue = modifierItemStrikeTaxValue;
        modifierItemsObj.modifierItemQuantity = 1;
        modifierGroupsArray[modifierGroupIndex].modifierItems = [];
        modifierGroupsArray[modifierGroupIndex].modifierItems.push(modifierItemsObj);
      }
    } else {
      modifierGroupsObj.modifierGroupId = modifierGroupId;
      modifierGroupsObj.modifierItems = [];
      modifierItemsObj.modifierTabid = modifierTabid;
      modifierItemsObj.modifierItemId = modifierItemId;
      modifierItemsObj.modifierItemName = modifierItemName;
      modifierItemsObj.modifierItemAmount = modifierItemAmount;
      modifierItemsObj.modifierItemTax = modifierItemTax;
      modifierItemsObj.modifierItemStrikeprice = modifierItemStrikeprice;
      modifierItemsObj.modifierItemStrikeValueBeforeTax = modifierItemStrikeValueBeforeTax;
      modifierItemsObj.modifierItemStrikeTaxValue = modifierItemStrikeTaxValue;
      modifierItemsObj.modifierItemQuantity = 1;
      modifierGroupsObj.modifierItems.push(modifierItemsObj);
      modifierGroupsArray.push(modifierGroupsObj);
    }

    //Push Modifier Group Data to this.state.cartData.
    var tempCartData = this.state.cartData;
    tempCartData[tempCartData.length - 1].modifierGroups = [];
    if (modifierGroupsArray.length > 0) {
      tempCartData[tempCartData.length - 1].modifierGroups.push(modifierGroupsArray);
    }
    //>// console.log("modifierItemRadioOnchange > tempCartData: ");
    //>// console.log(tempCartData);
    this.setState(
      {
        cartData: tempCartData,
      },
      () => {
        //Validate Modifier Group min/max Quantity.
        //>// this.validateModifierMinMaxQty(itemId, modifierGroupId, modifierGroupMinQty, modifierGroupMaxQty);
        this.validateModifierMinMaxQty(itemId, modifierGroupId, modifierItemId, modifierGroupMinQty, modifierGroupMaxQty);
        //Update Total.
        this.handleCalculateMenuItemTotal(itemId);
      }
    );
  };

  // add special instructions only to each item
  modifierModalFnbItemSpecialInstructions = (event) => {
    let tempCartData = this.state.cartData;
    tempCartData[tempCartData.length - 1].specialinstructions = event.target.value;
    this.setState({cartData: tempCartData});
  };

  //modifierItemQuantity = (event, counterFlag, itemId) => {
  modifierModalFnbItemQuantity = (event, counterFlag, fnbItem, fnbItemModifiers) => {
    var curObj = jQuery(event.target);
    var parentObj = curObj.parents(".itemCounter");
    var counterQuantity = parseInt(parentObj.find("input[type=text][readonly]").val());
    if (counterFlag == "countIncrement") {
      counterQuantity = counterQuantity + 1;
      if (counterQuantity > 1) {
        parentObj.find(".icControl.iccDecrement").removeClass("disabled");
        if (counterQuantity >= fnbItem.maximumqty) {
          parentObj.find(".icControl.iccIncrement").addClass("disabled");
        }
      }
    } else {
      counterQuantity = counterQuantity > 1 ? counterQuantity - 1 : 1;
      if (counterQuantity == 1) {
        parentObj.find(".icControl.iccDecrement").addClass("disabled");
      } else if (counterQuantity < fnbItem.maximumqty) {
        parentObj.find(".icControl.iccIncrement").removeClass("disabled");
      }
    }
    parentObj.find("input[type=text][readonly]").val(counterQuantity);
    var tempCartData = this.state.cartData;
    tempCartData[this.state.cartData.length - 1].quantity = counterQuantity;

    var paramFnbItemId = fnbItem.MenuItemId;
    // console.log("paramFnbItemId: " + paramFnbItemId);
    //ALternateItem.
    var cartLastItem = tempCartData[this.state.cartData.length - 1];
    if (fnbItem.fnbs_alternateitems && fnbItem.fnbs_alternateitems.length > 0 && fnbItem.id != cartLastItem.id) {
      // console.log("fnbItem.id: " + fnbItem.id);
      // console.log("cartLastItem.id: " + cartLastItem.id);
      var altItemIndex = fnbItem.fnbs_alternateitems.findIndex((x) => x.id == cartLastItem.id);
      if (altItemIndex != -1) {
        paramFnbItemId = fnbItem.fnbs_alternateitems[altItemIndex].id;
      }
    }
    // console.log("paramFnbItemId > altItem: " + paramFnbItemId);

    this.setState(
      {
        cartData: tempCartData,
      },
      () => {
        //this.handleCalculateMenuItemTotal(fnbItem.id);
        this.handleCalculateMenuItemTotal(paramFnbItemId);
      }
    );
  };

  validateModifierMinMaxQty = (fnbItemId, modifierGroupId, modifierItemId, modifierGroupMinQty, modifierGroupMaxQty) => {
    ////////console.log("Routing > validateModifierMinMaxQty()");
    console.log("fnbItemId: " + fnbItemId);
    console.log("modifierGroupId: " + modifierGroupId);
    console.log("modifierGroupMinQty: " + modifierGroupMinQty);
    console.log("modifierGroupMaxQty: " + modifierGroupMaxQty);
    var mgQuantityTotal = 0;
    //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId + " ul li")
    //>// Checkbox Count.
    mgQuantityTotal = jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId).find(".customCheckbox input:checked").length;
    console.log("validateModifierMinMaxQty() >>> Selected(Checkbox) > mgQuantityTotal: " + mgQuantityTotal);
    //>// Radio Count.
    mgQuantityTotal = mgQuantityTotal + jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId).find(".customRadio input:checked").length;
    console.log("validateModifierMinMaxQty() >>> Selected(customRadio) > mgQuantityTotal: " + mgQuantityTotal);
    //>// Counter Value.
    jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
      .find("ul li .itemCounter input")
      .each(function () {
        var curFcVal = parseInt(jQuery(this).val());
        console.log("validateModifierMinMaxQty() >>> .itemCounter > input: " + curFcVal);
        mgQuantityTotal = mgQuantityTotal + curFcVal;
      });
    console.log("validateModifierMinMaxQty() >>> Selected(itemCounter) > mgQuantityTotal: " + mgQuantityTotal);
    if (modifierGroupMinQty == 0 && modifierGroupMaxQty == 0) {
      console.log("0 => optional");
      //itemModifierGroupTitle = itemModifierGroupTitle + " (optional)";
    } else if (modifierGroupMinQty == 0 && modifierGroupMaxQty == 1) {
      console.log("1 => optional select upto 1");
      //optional select upto 1
      if (mgQuantityTotal == 1 && mgQuantityTotal == modifierGroupMaxQty) {
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find(".customCheckbox input:not(:checked)")
          .prop("disabled", true);
        //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .addClass("disabled");
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find("ul li .itemCounter .icControl.iccIncrement")
          .addClass("disabled");
      } else {
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find(".customCheckbox input:not(:checked)")
          .prop("disabled", false);
        //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .removeClass("disabled");
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find("ul li .itemCounter .icControl.iccIncrement")
          .removeClass("disabled");
      }
    } else if (modifierGroupMinQty == 1 && modifierGroupMaxQty == 1) {
      console.log("2 => Required");
      //Required
      if (mgQuantityTotal == 1 && mgQuantityTotal == modifierGroupMinQty && mgQuantityTotal == modifierGroupMaxQty) {
        console.log("2 => Required > if");
        //Previous checkbox layout.
        //// jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
        ////   .find(".customCheckbox input:not(:checked)")
        ////   .prop("disabled", true);
        //// //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .addClass("disabled");
        //// jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
        ////   .find("ul li .itemCounter .icControl.iccIncrement")
        ////   .addClass("disabled");
        //Current radio layout.
        //>// document.getElementById("modifierModalBtn").classList.add("disabled");
        // // // // // // // var calRequiredModifierGroup = 0;
        // // // // // // // var lastItemInCart = this.state.cartData[this.state.cartData.length - 1];
        // // // // // // // console.log("2 => Required > if > lastItemInCart: ");
        // // // // // // // console.log(lastItemInCart);
        // // // // // // // lastItemInCart.modifierGroups[0].map((mg) => {
        // // // // // // //   var sumModifierItemQuantity = 0;
        // // // // // // //   mg.modifierItems.map((mi) => {
        // // // // // // //     if (sumModifierItemQuantity == 0) {
        // // // // // // //       calRequiredModifierGroup = calRequiredModifierGroup + mi.modifierItemQuantity;
        // // // // // // //     }
        // // // // // // //   });
        // // // // // // // });
        // // // // // // // if (calRequiredModifierGroup == this.state.requiredModifierGroupCount) {
        // // // // // // //   document.getElementById("modifierModalBtn").classList.remove("disabled");
        // // // // // // // }
        this.validateModifierButton(fnbItemId);
      } else {
        console.log("2 => Required > else");
        //Previous checkbox layout.
        //// jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
        ////   .find(".customCheckbox input:not(:checked)")
        ////   .prop("disabled", false);
        //// //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .removeClass("disabled");
        //// jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
        ////   .find("ul li .itemCounter .icControl.iccIncrement")
        ////   .removeClass("disabled");
        //Current radio layout.
        //>// document.getElementById("modifierModalBtn").classList.remove("disabled");
        this.validateModifierButton(fnbItemId);
      }
    } else if (modifierGroupMinQty == 0 && modifierGroupMaxQty > 1 && modifierGroupMaxQty > modifierGroupMinQty) {
      console.log("3 => optional select upto maxQty");
      //optional select upto maxQty
      if (mgQuantityTotal > 1 && mgQuantityTotal > modifierGroupMinQty && mgQuantityTotal == modifierGroupMaxQty) {
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find(".customCheckbox input:not(:checked)")
          .prop("disabled", true);
        //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .addClass("disabled");
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find("ul li .itemCounter .icControl.iccIncrement")
          .addClass("disabled");
      } else {
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find(".customCheckbox input:not(:checked)")
          .prop("disabled", false);
        //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .removeClass("disabled");
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find("ul li .itemCounter .icControl.iccIncrement")
          .removeClass("disabled");
      }
    } else if (modifierGroupMinQty > 0 && modifierGroupMaxQty > 1 && modifierGroupMaxQty == modifierGroupMinQty) {
      console.log("4 => Required select maxQty");
      //Required select maxQty
      if (mgQuantityTotal > 1 && mgQuantityTotal == modifierGroupMinQty && mgQuantityTotal == modifierGroupMaxQty) {
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find(".customCheckbox input:not(:checked)")
          .prop("disabled", true);
        //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .addClass("disabled");
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find("ul li .itemCounter .icControl.iccIncrement")
          .addClass("disabled");
        this.validateModifierButton(fnbItemId);
      } else {
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find(".customCheckbox input:not(:checked)")
          .prop("disabled", false);
        //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .removeClass("disabled");
        jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
          .find("ul li .itemCounter .icControl.iccIncrement")
          .removeClass("disabled");
        this.validateModifierButton(fnbItemId);
      }
    } else if (modifierGroupMinQty > 0 && modifierGroupMaxQty > 1 && modifierGroupMaxQty > modifierGroupMinQty) {
      console.log("5 => Required select minQty upto maxQty");
      console.log("5 => Required select minQty upto maxQty > mgQuantityTotal: " + mgQuantityTotal);
      //Required select minQty upto maxQty
      if (mgQuantityTotal <= 0) {
        console.log("5 => Required select minQty upto maxQty >>> if");
        //>// document.getElementById("modifierModalBtn").classList.add("disabled");
        this.validateModifierButton(fnbItemId);
      } else {
        console.log("5 => Required select minQty upto maxQty >>> else");
        //if (mgQuantityTotal > 0 && mgQuantityTotal >= modifierGroupMinQty && mgQuantityTotal <= modifierGroupMaxQty) {
        if (mgQuantityTotal > 0 && mgQuantityTotal >= modifierGroupMinQty && mgQuantityTotal >= modifierGroupMaxQty) {
          console.log("5 => Required select minQty upto maxQty >>> else > if");
          jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
            .find(".customCheckbox input:not(:checked)")
            .prop("disabled", true);
          //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .addClass("disabled");
          jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
            .find("ul li .itemCounter .icControl.iccIncrement")
            .addClass("disabled");
          //>// document.getElementById("modifierModalBtn").classList.add("disabled");
          this.validateModifierButton(fnbItemId);
        } else {
          console.log("5 => Required select minQty upto maxQty >>> else > else");
          jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
            .find(".customCheckbox input:not(:checked)")
            .prop("disabled", false);
          //jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId) .find(".customCheckbox input:not(:checked) + label") .removeClass("disabled");
          jQuery("#fnbmmrwrsiWrap_" + fnbItemId + "_" + modifierGroupId)
            .find("ul li .itemCounter .icControl.iccIncrement")
            .removeClass("disabled");
          //>// document.getElementById("modifierModalBtn").classList.remove("disabled");
          this.validateModifierButton(fnbItemId);
        }
      }
    }
  };

  validateModifierButton = (fnbItem) => {
    console.log("validateModifierButton()");
    console.log("validateModifierButton() > fnbItem");
    console.log(fnbItem);
    let currentItem = this.state.fnbItemData;
    // console.log("validateModifierButton() > currentItem");
    // console.log(currentItem);
    let currentItemModifiers = this.state.fnbItemModifierData;
    // console.log("validateModifierButton() > currentItemModifiers");
    // console.log(currentItemModifiers);
    var lastItemInCart = this.state.cartData[this.state.cartData.length - 1];
    // console.log("validateModifierButton() > lastItemInCart");
    // console.log(lastItemInCart);
    var tempRequiredModifierGroupCount = 0;
    if (fnbItem == lastItemInCart.id) {
      console.log("validateModifierButton inside if");
      if (lastItemInCart.modifierGroups.length > 0) {
        console.log("if > lastItemInCart.modifierGroups.length");
        lastItemInCart.modifierGroups[0].map((mGroup) => {
          var getMGIndex = currentItemModifiers.findIndex((x) => x.ModifierGroupId == mGroup.modifierGroupId);
          if (getMGIndex != -1) {
            console.log("if > getMGIndex!=-1");
            var mgMinQty = currentItemModifiers[getMGIndex].MinimumItems;
            console.log("MinimumItems: " + mgMinQty);
            // var mgMaxQty = currentItemModifiers[getMGIndex].MaximumItems;
            // console.log("MinimumItems: " + mgMinQty + " mgMaxQty: " + mgMaxQty);
            var modifierItemTotalQty = 0;
            mGroup.modifierItems.map((mItem) => {
              modifierItemTotalQty = modifierItemTotalQty + mItem.modifierItemQuantity;
              if (modifierItemTotalQty == mgMinQty) {
                tempRequiredModifierGroupCount += 1;
              }
            });
          }
        });
        console.log("tempRequiredModifierGroupCount");
        console.log(tempRequiredModifierGroupCount);
        if (tempRequiredModifierGroupCount == this.state.requiredModifierGroupCount) {
          console.log("if > tempRequiredModifierGroupCount == this.state.requiredModifierGroupCount");
          document.getElementById("modifierModalBtn").classList.remove("disabled");
        } else {
          console.log("else > tempRequiredModifierGroupCount == this.state.requiredModifierGroupCount");
          document.getElementById("modifierModalBtn").classList.add("disabled");
        }
      } else {
        console.log("else > lastItemInCart.modifierGroups.length");
        document.getElementById("modifierModalBtn").classList.add("disabled");
      }
    } else {
      console.log("validateModifierButton inside else");
      document.getElementById("modifierModalBtn").classList.add("disabled");
    }
  };

  handleCalculateMenuItemTotal = (itemId) => {
    ////////console.log("Routing > handleCalculateMenuItemTotal()");
    var cartData = this.state.cartData;
    var modifierMenuItemTotal = 0;

    //cartData.map((menuItem) => {
    var menuItem = cartData[cartData.length - 1];
    if (menuItem.id == itemId) {
      modifierMenuItemTotal =
        modifierMenuItemTotal + (menuItem.strikeprice == -1 || menuItem.strikeprice == null ? menuItem.valuebeforetax * menuItem.quantity : menuItem.strikeValueBeforeTax * menuItem.quantity);
      if (menuItem.modifierGroups.length > 0) {
        menuItem.modifierGroups.map((modifierGroups) => {
          if (modifierGroups.length > 0) {
            modifierGroups.map((modifierGroup) => {
              if (modifierGroup.modifierItems.length > 0) {
                modifierGroup.modifierItems.map((modifierItem) => {
                  modifierMenuItemTotal =
                    modifierMenuItemTotal +
                    (modifierItem.modifierItemStrikeprice == -1 || modifierItem.modifierItemStrikeprice == null || menuItem.dealItem
                      ? modifierItem.modifierItemAmount * modifierItem.modifierItemQuantity * menuItem.quantity
                      : modifierItem.modifierItemStrikeValueBeforeTax * modifierItem.modifierItemQuantity * menuItem.quantity);
                });
              }
            });
          }
        });
      }
    }
    //});

    modifierMenuItemTotal = modifierMenuItemTotal.toFixed(2);
    this.setState(
      {
        tempModifierModalTotal: modifierMenuItemTotal,
      },
      () => {
        //////////console.log("modifierMenuItemTotal: " + modifierMenuItemTotal.toFixed(2));
        //////////console.log( "this.state.tempModifierModalTotal: " + this.state.tempModifierModalTotal );
      }
    );
  };

  handleInCartFnbItemQuantity = (event, counterFlag, fnbItem, index) => {
    var curObj = jQuery(event.target);
    var parentObj = curObj.parents(".itemCounter");
    var counterQuantity = parseInt(parentObj.find("input[type=text][readonly]").val());
    var tempCartData = this.state.cartData;
    if (counterFlag == "countIncrement") {
      fnbItem.repeatIndex = index;
      this.setState(
        {
          repeatItemData: fnbItem,
          repeatItemIndex: index,
        },
        () => {
          // // // // // var getTabIndex = this.state.fnbMenuItems.findIndex((x) => x.id === fnbItem.tabId);
          var getTabIndex = this.state.fnbMenuData.findIndex((x) => parseInt(x.MenuId) === parseInt(fnbItem.tabId));
          console.log("getTabIndex: " + getTabIndex);
          // // // // // /*Find tab index for deal items*/
          // // // // // if (getTabIndex == -1 && fnbItem.dealItem == true) {
          // // // // //   this.state.fnbMenuItems.map((fnbTabItem, index) => {
          // // // // //     var fnbMenuItems = fnbTabItem.fnbtabs_items;
          // // // // //     var fnbMenuItemsIndex = fnbMenuItems.findIndex((x) => x.id === fnbItem.id);
          // // // // //     if (fnbMenuItemsIndex != -1) {
          // // // // //       getTabIndex = index;
          // // // // //     }
          // // // // //   });
          // // // // // }
          // // // // // /*E.O.Find tab index for deal items*/
          // // // // // var getItemIndex = this.state.fnbMenuItems[getTabIndex].fnbtabs_items.findIndex((x) => x.id === fnbItem.id);
          // // // // // var selectedItemOriginalData = this.state.fnbMenuItems[getTabIndex].fnbtabs_items[getItemIndex];
          var getItemIndex = this.state.fnbMenuData[getTabIndex].Items.findIndex((x) => x.MenuItemId === fnbItem.id);
          var selectedItemOriginalData = this.state.fnbMenuData[getTabIndex].Items[getItemIndex];

          // // // // // if (getItemIndex == -1) {
          // // // // //   this.state.fnbMenuItems[getTabIndex].fnbtabs_items.map((fnbTabItem, index) => {
          // // // // //     if (fnbTabItem.fnbs_alternateitems && fnbTabItem.fnbs_alternateitems.length > 0) {
          // // // // //       var altItemIndex = fnbTabItem.fnbs_alternateitems.findIndex((x) => x.id === fnbItem.id);
          // // // // //       if (altItemIndex != -1) {
          // // // // //         //>// console.log("if > altItemIndex: " + altItemIndex);
          // // // // //         getItemIndex = index;
          // // // // //         //>// console.log("if > altItemIndex > getItemIndex: " + getItemIndex);
          // // // // //         selectedItemOriginalData = this.state.fnbMenuItems[getTabIndex].fnbtabs_items[getItemIndex].fnbs_alternateitems[altItemIndex];
          // // // // //       } else {
          // // // // //         //>// console.log("else > altItemIndex1: " + altItemIndex);
          // // // // //       }
          // // // // //     }
          // // // // //   });
          // // // // // }

          // // // // // if (selectedItemOriginalData.modifierGroups.length == 0 && selectedItemOriginalData.smartModifiers.length == 0) {
          if (selectedItemOriginalData.Modfiergroups == 0 || selectedItemOriginalData.Modfiergroups == "0") {
            this.handleRepeatPreviousSelection();
          } else {
            // // // // Repeat Item Modal
            // // // var repeatModalEl = document.getElementById("repeatItem");
            // // // var myModal = new Modal(repeatModalEl);
            // // // myModal.show();
            // Repeat Item Drawer
            //>// this.cartDrawerToggle();
            this.state.windowWidth < 992 && this.cartDrawerToggle();
            this.openRepeatItemDrawer();
          }
        }
      );
    } else {
      counterQuantity = counterQuantity > 0 ? counterQuantity - 1 : 0;
      //////* if (counterQuantity <= 0 && !parentObj.hasClass("iczActive")) {
      //////   parentObj.addClass("iczActive");
      //////   parentObj.find(".icControl.iccDecrement").addClass("disabled");
      ////// }*/
      parentObj.find("input[type=text][readonly]").val(counterQuantity);
      if (index != -1) {
        if (counterQuantity <= 0) {
          tempCartData.splice(index, 1);
        } else {
          tempCartData[index].quantity = counterQuantity;
        }
      }

      this.setState({cartData: tempCartData}, () => {
        this.loadStateData();
      });
    }

    //this.setState({ cartData: tempCartData, });
  };

  handleRepeatPreviousSelection = (event) => {
    var tempRepeatItemData = this.state.repeatItemData;
    var tempRepeatItemDataQty = parseInt(tempRepeatItemData.quantity);

    var tempCartData = this.state.cartData;
    var findRepeatItemIndex = tempRepeatItemData.repeatIndex;
    if (findRepeatItemIndex != -1) {
      tempCartData[findRepeatItemIndex].quantity = tempRepeatItemDataQty + 1;
      this.setState(
        {
          cartData: tempCartData,
        },
        () => {
          //console.log("setting data");
          this.loadStateData();
        }
      );
    }
  };

  populateItemModifierItems = (mgData, smData) => {
    ////////console.log("Routing > populateItemModifierItems()");
    ////////console.log(mgData);
    ////////console.log(smData);
    var modifierItemsAr = [];
    var modifierItemsSt = "";
    if (mgData.length > 0) {
      mgData.map((mgsItem) => {
        if (mgsItem.length > 0) {
          mgsItem.map((mgItem) => {
            if (mgItem.modifierItems.length > 0) {
              mgItem.modifierItems.map((miItem) => {
                //////////console.log(miItem.modifierItemName);
                //modifierItemsAr.push(miItem.modifierItemName);
                var minStr = miItem.modifierItemQuantity == 1 ? miItem.modifierItemName : miItem.modifierItemName + "(" + miItem.modifierItemQuantity + ")";
                modifierItemsAr.push(minStr);
              });
            }
          });
        }
      });
    }
    if (modifierItemsAr.length > 0) {
      //////////console.log("modifierItemsAr");
      //////////console.log(modifierItemsAr);
      modifierItemsSt = modifierItemsAr.join(", ");
      //>// modifierItemsSt = smData.length > 0 ? modifierItemsSt + ", " : modifierItemsSt;
      //////////console.log("modifierItemsSt: " + modifierItemsSt);
    }
    return modifierItemsSt;
  };

  //Cart > Item(Per Row) Total Calculation.
  calculateItemRowTotal = (itemStrikeprice, itemVBT, itemQty, modifierGroupsData, dealItemFlag) => {
    var tempItemTotal = 0;
    tempItemTotal = tempItemTotal + itemVBT * itemQty;
    modifierGroupsData.map((mgsItem) => {
      if (mgsItem.length > 0) {
        mgsItem.map((mgItem) => {
          if (mgItem.modifierItems.length > 0) {
            mgItem.modifierItems.map((mItem, index) => {
              //var modifierItemTotal = mItem.modifierItemAmount * mItem.modifierItemQuantity * itemQty;
              /**
                //For after login strikeprice calculation:
                //Instead of "this.state.cartData > item > modifierItemStrikeprice" used "this.state.cartData > item > Strikeprice"
                //to calculate the modifier group > modifier item tax

                //For dealsItem > modifierItems we are not considering the following:
                //strikeprice(modifierItemStrikeprice), strikeValueBeforeTax(modifierItemStrikeValueBeforeTax) & strikeTaxValue(modifierItemStrikeTaxValue).
              **/
              // var modifierItemTotal =
              //   itemStrikeprice == -1 || dealItemFlag
              //     ? mItem.modifierItemAmount * mItem.modifierItemQuantity * itemQty
              //     : mItem.modifierItemStrikeValueBeforeTax
              //     ? mItem.modifierItemStrikeValueBeforeTax * mItem.modifierItemQuantity * itemQty
              //     : 0;
              var modifierItemTotal =
                itemStrikeprice == -1 || itemStrikeprice == null || dealItemFlag
                  ? mItem.modifierItemAmount * mItem.modifierItemQuantity * itemQty
                  : mItem.strikeprice != -1 || mItem.strikeprice != null
                  ? mItem.modifierItemStrikeValueBeforeTax * mItem.modifierItemQuantity * itemQty
                  : 0;
              tempItemTotal = tempItemTotal + modifierItemTotal;
            });
          }
        });
      }
    });
    tempItemTotal = "$" + parseFloat(tempItemTotal).toFixed(2) + "";
    return tempItemTotal;
  };

  //Cart - SubTotal Calculation.
  calculateCartSubtotal = (cData) => {
    ////////console.log("ColumnRight > calculateCartSubtotal()");
    //////////console.log(cData);
    var subTotal = 0;
    if (cData.length > 0) {
      cData.map((item) => {
        if (item.itemInCartFlag) {
          //subTotal = subTotal + item.valuebeforetax * item.quantity;
          subTotal = subTotal + (item.strikeprice == -1 || item.strikeprice == null ? item.valuebeforetax * item.quantity : item.strikeValueBeforeTax * item.quantity);
          if (item.modifierGroups.length > 0) {
            item.modifierGroups.map((mgsItem) => {
              if (mgsItem.length > 0) {
                mgsItem.map((mgItem) => {
                  if (mgItem.modifierItems.length > 0) {
                    mgItem.modifierItems.map((mItem) => {
                      //subTotal = subTotal + mItem.modifierItemAmount * mItem.modifierItemQuantity * item.quantity;
                      /**
                        //For after login strikeprice calculation:
                        //Instead of "this.state.cartData > item > modifierItemStrikeprice" used "this.state.cartData > item > Strikeprice"
                        //to calculate the modifier group > modifier item tax

                        //For dealsItem > modifierItems we are not considering the following:
                        //strikeprice(modifierItemStrikeprice), strikeValueBeforeTax(modifierItemStrikeValueBeforeTax) & strikeTaxValue(modifierItemStrikeTaxValue).
                      **/
                      // subTotal =
                      //   subTotal +
                      //   (item.strikeprice == -1 || item.dealItem
                      //     ? mItem.modifierItemAmount * mItem.modifierItemQuantity * item.quantity
                      //     : mItem.modifierItemStrikeValueBeforeTax
                      //     ? mItem.modifierItemStrikeValueBeforeTax * mItem.modifierItemQuantity * item.quantity
                      //     : 0);
                      subTotal =
                        subTotal +
                        (item.strikeprice == -1 || item.strikeprice == null || item.dealItem
                          ? mItem.modifierItemAmount * mItem.modifierItemQuantity * item.quantity
                          : mItem.strikeprice != -1 || mItem.strikeprice != null
                          ? mItem.modifierItemStrikeValueBeforeTax * mItem.modifierItemQuantity * item.quantity
                          : 0);
                    });
                  }
                });
              }
            });
          }
        }
      });
    }
    subTotal = subTotal.toFixed(2);
    return "$" + subTotal;
  };

  //Cart - Tax Calculation.
  calculateCartTax = (cData) => {
    ////////console.log("ColumnRight > calculateCartTax()");
    //////////console.log(cData);
    var taxTotal = 0;
    if (cData.length > 0) {
      cData.map((item) => {
        if (item.itemInCartFlag) {
          //taxTotal = taxTotal + item.taxValue * item.quantity;
          taxTotal = taxTotal + (item.strikeprice == -1 || item.strikeprice == null ? item.taxValue * item.quantity : item.strikeTaxValue * item.quantity);
          if (item.modifierGroups.length > 0) {
            item.modifierGroups.map((mgsItem) => {
              if (mgsItem.length > 0) {
                mgsItem.map((mgItem) => {
                  if (mgItem.modifierItems.length > 0) {
                    mgItem.modifierItems.map((mItem) => {
                      //taxTotal = taxTotal + mItem.modifierItemTax * mItem.modifierItemQuantity * item.quantity;
                      /**
                        //For after login strikeprice calculation:
                        //Instead of "this.state.cartData > item > modifierItemStrikeprice" used "this.state.cartData > item > Strikeprice"
                        //to calculate the modifier group > modifier item tax

                        //For dealsItem > modifierItems we are not considering the following:
                        //strikeprice(modifierItemStrikeprice), strikeValueBeforeTax(modifierItemStrikeValueBeforeTax) & strikeTaxValue(modifierItemStrikeTaxValue).
                      **/
                      // taxTotal =
                      //   taxTotal +
                      //   (item.strikeprice == -1 || item.dealItem
                      //     ? mItem.modifierItemTax * mItem.modifierItemQuantity * item.quantity
                      //     : mItem.modifierItemStrikeTaxValue
                      //     ? mItem.modifierItemStrikeTaxValue * mItem.modifierItemQuantity * item.quantity
                      //     : 0);
                      taxTotal =
                        taxTotal +
                        (item.strikeprice == -1 || item.strikeprice == null || item.dealItem
                          ? mItem.modifierItemTax * mItem.modifierItemQuantity * item.quantity
                          : mItem.strikeprice != -1 || mItem.strikeprice != null
                          ? mItem.modifierItemStrikeTaxValue * mItem.modifierItemQuantity * item.quantity
                          : 0);
                    });
                  }
                });
              }
            });
          }
        }
      });
    }
    taxTotal = taxTotal.toFixed(2);
    return "$" + taxTotal;
  };

  //Cart - Grand Total Calculation.
  calculateCartGrandTotal = (cData) => {
    ////////console.log("ColumnRight > calculateCartGrandTotal()");
    //////////console.log(cData);
    var grandTotal = 0;
    var taxTotal = 0;
    var cartGrandTotal = 0;
    if (cData.length > 0) {
      cData.map((item) => {
        if (item.itemInCartFlag) {
          //grandTotal = grandTotal + item.valuebeforetax * item.quantity;
          grandTotal = grandTotal + (item.strikeprice == -1 || item.strikeprice == null ? item.valuebeforetax * item.quantity : item.strikeValueBeforeTax * item.quantity);
          //////////console.log("grandTotal: " + grandTotal);
          if (item.modifierGroups.length > 0) {
            item.modifierGroups.map((mgsItem) => {
              if (mgsItem.length > 0) {
                mgsItem.map((mgItem) => {
                  if (mgItem.modifierItems.length > 0) {
                    mgItem.modifierItems.map((mItem) => {
                      //grandTotal = grandTotal + mItem.modifierItemAmount * mItem.modifierItemQuantity * item.quantity + mItem.modifierItemTax * mItem.modifierItemQuantity * item.quantity;
                      /**
                        //For after login strikeprice calculation:
                        //Instead of "this.state.cartData > item > modifierItemStrikeprice" used "this.state.cartData > item > Strikeprice"
                        //to calculate the modifier group > modifier item tax

                        //For dealsItem > modifierItems we are not considering the following:
                        //strikeprice(modifierItemStrikeprice), strikeValueBeforeTax(modifierItemStrikeValueBeforeTax) & strikeTaxValue(modifierItemStrikeTaxValue).
                      **/
                      // var modifierItemTotal =
                      //   item.strikeprice == -1 || item.dealItem
                      //     ? mItem.modifierItemAmount * mItem.modifierItemQuantity * item.quantity
                      //     : mItem.modifierItemStrikeValueBeforeTax
                      //     ? mItem.modifierItemStrikeValueBeforeTax * mItem.modifierItemQuantity * item.quantity
                      //     : 0;
                      // var modifierItemTaxTotal =
                      //   item.strikeprice == -1 || item.dealItem
                      //     ? mItem.modifierItemTax * mItem.modifierItemQuantity * item.quantity
                      //     : mItem.modifierItemStrikeTaxValue
                      //     ? mItem.modifierItemStrikeTaxValue * mItem.modifierItemQuantity * item.quantity
                      //     : 0;
                      var modifierItemTotal =
                        item.strikeprice == -1 || item.strikeprice == null || item.dealItem
                          ? mItem.modifierItemAmount * mItem.modifierItemQuantity * item.quantity
                          : mItem.strikeprice != -1 || mItem.strikeprice != null
                          ? mItem.modifierItemStrikeValueBeforeTax * mItem.modifierItemQuantity * item.quantity
                          : 0;
                      var modifierItemTaxTotal =
                        item.strikeprice == -1 || item.strikeprice == null || item.dealItem
                          ? mItem.modifierItemTax * mItem.modifierItemQuantity * item.quantity
                          : mItem.strikeprice != -1 || mItem.strikeprice != null
                          ? mItem.modifierItemStrikeTaxValue * mItem.modifierItemQuantity * item.quantity
                          : 0;
                      grandTotal = grandTotal + modifierItemTotal + modifierItemTaxTotal;
                      //////////console.log("grandTotal: " + grandTotal);
                    });
                  }
                });
              }
            });
          }
          taxTotal = taxTotal + (item.strikeprice == -1 || item.strikeprice == null ? item.taxValue * item.quantity : item.strikeTaxValue * item.quantity);
        }
      });
    }
    //////////console.log("grandTotal: " + grandTotal);
    //////////console.log("taxTotal: " + taxTotal);
    cartGrandTotal = grandTotal + taxTotal;
    //////////console.log("cartGrandTotal: " + cartGrandTotal);
    cartGrandTotal = cartGrandTotal.toFixed(2);

    //On Partial Giftcard.
    // if (this.state.redeemedGiftcards.length > 0) {
    //   //console.log("cartGrandTotal before giftcard: " + cartGrandTotal);
    //   var gfTotal = 0;
    //   var redeemedGiftcards = this.state.redeemedGiftcards;
    //   redeemedGiftcards.map((giftcartItem) => {
    //     if (giftcartItem.orders_paymenttypes.length > 0)
    //       giftcartItem.orders_paymenttypes.map((ptItem, index) => {
    //         if (ptItem.type == "giftcard") {
    //           gfTotal = gfTotal + ptItem.amount;
    //         }
    //       });
    //   });
    //   cartGrandTotal = (cartGrandTotal - gfTotal).toFixed(2);
    //   //console.log("cartGrandTotal after giftcard: " + cartGrandTotal);
    // }

    return "$" + cartGrandTotal;
  };

  deleteItemFromCart = (index) => {
    //>// console.log("deleteItemFromCart()");
    let cartData = this.state.cartData;
    cartData.splice(index, 1);
    let createOrderData = this.state.createOrderData;
    createOrderData.fnb = cartData;
    this.setState({cartData, createOrderData}, () => {
      this.loadStateData();
      // // // // // this.populateCookieData(false);

      //Remove Redemeed Giftcard.
      // if (this.state.cartData.length == 0 && this.state.redeemedGiftcards.length > 0) {
      //   var redemeedGiftcard = "";
      //   //this.state.redeemedGiftcards.map((giftcartItem) => {
      //   if (this.state.redeemedGiftcards[0].orders_paymenttypes.length > 0) {
      //     this.state.redeemedGiftcards[0].orders_paymenttypes.map((ptItem) => {
      //       if (ptItem.type == "giftcard") {
      //         redemeedGiftcard = ptItem.cardinformation.cardNumber;
      //       }
      //     });
      //   }
      //   //});
      //   console.log("redemeedGiftcard: " + redemeedGiftcard);
      //   if (redemeedGiftcard != "") {
      //     this.removeRedemeedGiftcard(redemeedGiftcard);
      //   }
      // }
    });
  };

  addItemToCart = (itemId) => {
    try {
      let temp = "";
      this.state.cartData[this.state.cartData.length - 1].modifierGroups?.map((modifierGroupItem) => {
        modifierGroupItem?.map((cartItemModifier) => {
          cartItemModifier?.modifierItems?.map((item) => {
            temp += item.modifierItemName + " (" + item.modifierItemQuantity + "), ";
          });
        });
      });
      window.Moengage.track_event("FnB topping and add on select ", {
        State: this.state.compHomeSelectedOptions.stateFullString,
        "Cinema Location": this.state.compHomeSelectedOptions.cinemaFullString,
        "Order Method": this.state.compHomeSelectedOptions.deliverOption,
        Showdate: this.state.compHomeSelectedOptions.showDate,
        Moviename: this.state.compHomeSelectedOptions.movieFullString,
        Showtime: this.state.compHomeSelectedOptions.showTimeFullString,
        "Seat number": this.state.compHomeSelectedOptions.seatNumber,
        "Delivery Time": this.state.compHomeSelectedOptions.deliverToSeatTimeFullString,
        "FnB type": this.state.menuItemSelected.Name,
        "FnB Item selected": this.state.fnbItemData.Name,
        "Add on/Topping": temp,
        Quantity: this.state.cartData[this.state.cartData.length - 1].quantity,
      });
    } catch (error) {
      console.log(error);
    }
    var justIncreaseQtyIndex = 0;
    var tempCartData = this.state.cartData;
    var menuItemIndex = tempCartData.length - 1;
    var itemUniqueIdentifier = tempCartData[menuItemIndex].id;
    itemUniqueIdentifier = itemUniqueIdentifier + "_" + tempCartData[menuItemIndex].SalesItemId;

    if (tempCartData[menuItemIndex].modifierGroups.length != 0) {
      var modiferGroupArray = [];
      // tempCartData[menuItemIndex].modifierGroups[0][0].modifierItems.map((cartItemModifier) => {
      tempCartData[menuItemIndex].modifierGroups[0].map((modifierGroupItem) => {
        modifierGroupItem.modifierItems.map((cartItemModifier) => {
          modiferGroupArray.push(cartItemModifier.modifierItemId + cartItemModifier.modifierItemQuantity);
        });
      });
      itemUniqueIdentifier += modiferGroupArray.sort().join("");
    }
    var justIncreaseQtyIndex = this.state.cartData.findIndex((x) => x.itemUniqueIdentifier == itemUniqueIdentifier);
    if (justIncreaseQtyIndex != -1) {
      var counterQuantity = parseInt(jQuery("#modalFnbModifierQuantity").val());
      tempCartData[justIncreaseQtyIndex].specialinstructions = this.state.cartData[this.state.cartData.length - 1].specialinstructions;
      // tempCartData[justIncreaseQtyIndex].quantity = tempCartData[justIncreaseQtyIndex].quantity + 1;
      tempCartData[justIncreaseQtyIndex].quantity = tempCartData[justIncreaseQtyIndex].quantity + counterQuantity;
    } else {
      var menuItemIndex = tempCartData.length - 1;
      tempCartData[menuItemIndex].itemInCartFlag = true;
      tempCartData[menuItemIndex].itemUniqueIdentifier = itemUniqueIdentifier;
    }
    this.setState(
      {
        cartData: tempCartData,
        tempModifierModalTotal: 0,
      },
      () => {
        modifierGroupsArray = []; //Flushing global modifierGroupsArray varible.
        this.loadStateData();
      }
    );
  };

  cartDrawerToggle = () => {
    console.log("cartDrawerToggle()");
    var cartDrawerState = this.state.cartDrawer;
    this.setState(
      {
        cartDrawer: cartDrawerState ? false : true,
      },
      () => {
        if (this.state.cartDrawer) {
          document.body.className += " cartDrawerOpen";
          if (jQuery(window).width() < 992 && jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").length > 0) {
            var drawerMaxHeight = jQuery(window).height() * 0.9;
            var cartH3Height = jQuery(".pcpCart h3").outerHeight(true);
            var buttonHeight = jQuery(".pcpCart .pcpcAction").outerHeight(true);
            var totalStrapHeight = jQuery(".pcpCart .pcpBookingsummary .pcpbsInner .pcpbsTotalstrap").outerHeight(true);
            // // // // // console.log("drawerMaxHeight: " + drawerMaxHeight);
            // // // // // console.log("cartH3Height: " + cartH3Height);
            // // // // // console.log("buttonHeight: " + buttonHeight);
            // // // // // console.log("totalStrapHeight: " + totalStrapHeight);
            jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").css("max-height", parseInt(drawerMaxHeight - cartH3Height - buttonHeight - totalStrapHeight));
          }
        } else {
          document.body.className = document.body.className.replace("cartDrawerOpen", "");
          jQuery(".pcpCart.pcpCartfull .pcpBookingsummary .pcpbsInner .pcpbsContainer").css("max-height", "");
        }
      }
    );
  };

  populateCookieData = (redirectFlag) => {
    console.log("populateCookieData()");
    var stateCartData = this.state.cartData;
    if (stateCartData.length > 0) {
      var fnbCookieDataArr = [];
      var fnbMenuSelectedArr = [];
      stateCartData.map((cartItem, index) => {
        fnbMenuSelectedArr.push(cartItem.id);
        var fnbCookieDataObj = new Object();
        fnbCookieDataObj.tabId = cartItem.tabId; // Not part of the cookie structure
        fnbCookieDataObj.tabName = cartItem.tabName; // Not part of the cookie structure
        fnbCookieDataObj.MenuName = cartItem.itemName;
        fnbCookieDataObj.Modifierstext = "";
        fnbCookieDataObj.order_items = new Object();
        fnbCookieDataObj.order_items.ItemOrderingMode = 0;
        fnbCookieDataObj.order_items.MenuItemId = cartItem.id;
        fnbCookieDataObj.order_items.Modifiers = [];
        fnbCookieDataObj.order_items.Quantity = cartItem.quantity;
        fnbCookieDataObj.order_items.SalesItemId = cartItem.SalesItemId;
        fnbCookieDataObj.order_items.Section1Type = 0;
        fnbCookieDataObj.order_items.Section2Type = 0;
        fnbCookieDataObj.order_items.SpecialInstructions = cartItem.specialinstructions;
        fnbCookieDataObj.order_items.IsUpsize = cartItem.Upsize;
        fnbCookieDataObj.order_items.IsCrossSell = "0";
        fnbCookieDataObj.order_items.IsUpSell = "0";
        fnbCookieDataObj.order_items.IsLastChance = "0";
        fnbCookieDataObj.order_items.PriceDifferent = cartItem.PriceDifferent;
        fnbCookieDataObj.order_items.IsAlcohol = cartItem.IsAlcohol; // Alcohol Item - true/false
        fnbCookieDataObj.order_items.POSItemId = cartItem.salesItemIdPOSItemId;
        fnbCookieDataObj.order_items.Price = cartItem.salesItemIdPrice;
        var modifiersTotalPrice = 0;
        if (cartItem.modifierGroups.length > 0) {
          var modifierGroupArr = [];
          var modifierListArr = [];
          cartItem.modifierGroups.map((modifierGroupItem) => {
            //>// console.log("modifierGroupItem");
            //>// console.log(modifierGroupItem);
            modifierGroupItem.map((mgiItem) => {
              if (mgiItem.modifierItems.length > 0) {
                mgiItem.modifierItems.map((modifierItem) => {
                  var modifierItemObj = new Object();

                  modifiersTotalPrice =
                    modifiersTotalPrice +
                    (cartItem.strikeprice == -1 || cartItem.strikeprice == null
                      ? modifierItem.modifierItemAmount * modifierItem.modifierItemQuantity
                      : modifierItem.strikeprice != -1 || modifierItem.strikeprice != null
                      ? modifierItem.modifierItemStrikeValueBeforeTax * modifierItem.modifierItemQuantity
                      : 0);

                  modifierItemObj.Action = "Default";
                  modifierItemObj.ItemOptionGroupId = mgiItem.modifierGroupId;
                  modifierItemObj.PizzaType = "";
                  modifierItemObj.Quantity = modifierItem.modifierItemQuantity;
                  modifierItemObj.SalesItemOptionId = modifierItem.modifierItemId;
                  modifierItemObj.modifierItemName = modifierItem.modifierItemName; // Not part of the cookie structure
                  modifierItemObj.modifierItemAmount = modifierItem.modifierItemAmount; // Not part of the cookie structure
                  modifierGroupArr.push(modifierItemObj);
                  modifierListArr.push(modifierItem.modifierItemName);
                });
              }
            });
            // if (modifierGroupItem[0].modifierItems.length > 0) {
            //   modifierGroupItem[0].modifierItems.map((modifierItem) => {
            //     var modifierItemObj = new Object();
            //     modifierItemObj.Action = "Default";
            //     modifierItemObj.ItemOptionGroupId = modifierGroupItem[0].modifierGroupId;
            //     modifierItemObj.PizzaType = "";
            //     modifierItemObj.Quantity = modifierItem.modifierItemQuantity;
            //     modifierItemObj.SalesItemOptionId = modifierItem.modifierItemId;
            //     modifierGroupArr.push(modifierItemObj);
            //   });
            // }
          });
          fnbCookieDataObj.order_items.Modifiers = modifierGroupArr;
          // fnbCookieDataObj.Modifierstext = modifierListArr.sort().join(", ");
          fnbCookieDataObj.Modifierstext = modifierListArr.join(", ");
        }
        fnbCookieDataObj.ItemModifiersPrcie = modifiersTotalPrice.toFixed(2);
        // fnbCookieDataObj.ItemPrice = cartItem.strikeprice == -1 || cartItem.strikeprice == null ? cartItem.valuebeforetax : cartItem.strikeValueBeforeTax;
        fnbCookieDataObj.ItemPrice = cartItem.strikeprice == -1 || cartItem.strikeprice == null ? cartItem.valuebeforetax : cartItem.strikeValueBeforeTax;
        fnbCookieDataArr.push({[cartItem.id]: fnbCookieDataObj});
      });

      // var fnbMenuSelectedStr = fnbMenuSelectedArr.length > 0 ? fnbMenuSelectedArr.sort().join("-") : "";
      var fnbMenuSelectedStr = fnbMenuSelectedArr.length > 0 ? fnbMenuSelectedArr.join("-") : "";
      console.log("fnbCookieDataArr.length: " + fnbCookieDataArr.length);
      console.log("fnbCookieDataArr[]");
      console.log(fnbCookieDataArr);
      console.log("fnbMenuSelectedArr");
      console.log(fnbMenuSelectedArr);
      console.log("fnbMenuSelectedStr: " + fnbMenuSelectedStr);

      this.setState(
        {
          setReviewScreenCartDataCount: false,
        },
        () => {
          this.loadStateData();
          if (fnbCookieDataArr.length > 0) {
            // document.cookie = "accessToken=" + response.data.accessToken;
            // document.cookie = "refreshToken=" + response.data.refreshToken;
            document.cookie = "menusselected=" + fnbMenuSelectedStr;
            document.cookie = "fnbCartData=" + JSON.stringify(fnbCookieDataArr);
            localStorage.setItem("fnbCartData", JSON.stringify(fnbCookieDataArr));
            localStorage.setItem("fnbMovieData", JSON.stringify(this.state.compHomeSelectedOptions));
            document.cookie = "theatre_code=" + this.state.compHomeSelectedOptions.cinema;
            document.cookie = "theatre_name=" + this.state.compHomeSelectedOptions.cinemaFullString;
            document.cookie = "theatre_state=" + this.state.compHomeSelectedOptions.stateFullString; // Wisconsin
            document.cookie = "theatre_time_zone=" + "America/Chicago"; //America/Chicago
            document.cookie = "flow_name=" + this.state.compHomeSelectedOptions.deliverOption; //Pickup
            document.cookie =
              "fb_selected_time=" + this.state.compHomeSelectedOptions.deliverOption == "Delivery to your seat" ||
              this.state.compHomeSelectedOptions.deliverOption == "Concession Pickup + Food/Alcohol Delivery"
                ? this.state.compHomeSelectedOptions.deliverToSeatTime
                : this.state.compHomeSelectedOptions.pickUpTime; // 12:15%20AM
            document.cookie =
              "fb_selected_delivery_date_time=" + this.state.compHomeSelectedOptions.deliverOption == "Delivery to your seat" ||
              this.state.compHomeSelectedOptions.deliverOption == "Concession Pickup + Food/Alcohol Delivery"
                ? this.state.compHomeSelectedOptions.deliverToSeatTimeFullString
                : this.state.compHomeSelectedOptions.pickUpTimeFullString; //2022-11-12%2000:15
            if (redirectFlag) {
              window.open(process.env.REACT_APP_PHPURL + "fnb/fnbpurchaseinfo", "_self");
            }
          }
        }
      );
    }
  };

  setReviewScreenCartData12345 = () => {
    console.log("setReviewScreenCartData()");
    // var menunSelected = document.cookie("menusselected");
    console.log("0 this.state.cartData");
    console.log(this.state.cartData);
    this.setState(
      {
        cartData: [],
      },
      () => {
        console.log("1 this.state.cartData");
        console.log(this.state.cartData);
        let reviewScreenCartData = JSON.parse(localStorage.getItem("fnbCartData"));
        var cookieName = "menusselected";
        var menuSelected = null;
        var cookieArr = document.cookie.split(";");
        for (var i = 0; i < cookieArr.length; i++) {
          var cookiePair = cookieArr[i].split("=");
          if (cookieName === cookiePair[0].trim()) {
            // return decodeURIComponent(cookiePair[1]);
            menuSelected = decodeURIComponent(cookiePair[1]);
          }
        }
        // // console.log("menunSelected: " + menuSelected);
        if (menuSelected !== null) {
          var newCartDataArr = [];
          //>// var fnbMenuData = this.state.fnbMenuData;
          var menuSelectedArr = menuSelected.split("-");
          menuSelectedArr.map((menuId, index) => {
            console.log("menuSelectedArr > index:" + index);
            console.log("menuId: " + menuId);
            reviewScreenCartData.map((rscItem, index) => {
              console.log("reviewScreenCartData > index:" + index);
              if (rscItem[menuId] && typeof rscItem[menuId] !== typeof undefined) {
                console.log("if >>> rscItem[menuId] && typeof rscItem[menuId] !== typeof undefined");
                // // console.log("rscItem[menuId]: ");
                // // console.log(rscItem[menuId]);
                var itemObj = new Object();
                itemObj.tabId = rscItem[menuId].tabId;
                itemObj.tabName = rscItem[menuId].tabName;
                itemObj.itemInCartFlag = true;
                itemObj.id = rscItem[menuId].order_items.MenuItemId;
                itemObj.SalesItemId = rscItem[menuId].order_items.SalesItemId;
                itemObj.itemName = rscItem[menuId].MenuName;
                //>// itemObj.valuebeforetax = Number(rscItem[menuId].ItemPrice - rscItem[menuId].ItemModifiersPrcie).toFixed(2);
                itemObj.valuebeforetax = Number(rscItem[menuId].ItemPrice).toFixed(2);
                itemObj.taxValue = 0;
                itemObj.strikeprice = -1;
                itemObj.strikeValueBeforeTax = 0;
                itemObj.strikeTaxValue = 0;
                // console.log("rscItem[menuId].order_items.Quantity: " + rscItem[menuId].order_items.Quantity);
                itemObj.quantity = parseInt(rscItem[menuId].order_items.Quantity);
                itemObj.modifierGroups = [];
                itemObj.specialinstructions = rscItem[menuId].order_items.SpecialInstructions;
                itemObj.Upsize = rscItem[menuId].order_items.IsUpsize;
                itemObj.PriceDifferent = rscItem[menuId].order_items.PriceDifferent;
                itemObj.modifierGroups = [];
                if (rscItem[menuId].order_items.Modifiers.length == 0) {
                  // // // // // console.log("No Modifiers");
                  itemObj.itemUniqueIdentifier = itemObj.tabId + "_" + rscItem[menuId].order_items.MenuItemId;
                } else {
                  // // // // // console.log("With Modifiers");
                  itemObj.itemUniqueIdentifier = rscItem[menuId].order_items.MenuItemId;

                  var modifiersArr = [];
                  let modifiersData = rscItem[menuId].order_items.Modifiers;
                  var iuiArr = []; // itemUniqueIdentifier
                  modifiersData.map((mdItem) => {
                    // // // // // console.log("modifiersArr");
                    // // // // // console.log(modifiersArr);
                    var modifiersObj = new Object();
                    var modifiersItemsObj = new Object();
                    var modifierGroupIndex = modifiersArr.findIndex((x) => x.modifierGroupId === mdItem.ItemOptionGroupId);
                    if (modifierGroupIndex == -1) {
                      // // // // // console.log("modifierGroupIndex == -1");
                      modifiersObj.modifierGroupId = mdItem.ItemOptionGroupId;
                      modifiersObj.modifierItems = [];
                      modifiersItemsObj.modifierTabid = "";
                      modifiersItemsObj.modifierItemId = mdItem.SalesItemOptionId;
                      modifiersItemsObj.modifierItemName = mdItem.modifierItemName;
                      modifiersItemsObj.modifierItemAmount = mdItem.modifierItemAmount;
                      modifiersItemsObj.modifierItemTax = 0;
                      modifiersItemsObj.modifierItemStrikeprice = -1;
                      modifiersItemsObj.modifierItemStrikeValueBeforeTax = 0;
                      modifiersItemsObj.modifierItemStrikeTaxValue = 0;
                      // console.log("if > mdItem.Quantity: " + mdItem.Quantity);
                      modifiersItemsObj.modifierItemQuantity = parseInt(mdItem.Quantity);
                      modifiersObj.modifierItems.push(modifiersItemsObj);
                      modifiersArr.push(modifiersObj);
                    } else {
                      // // // // // console.log("modifierGroupIndex == " + modifierGroupIndex);
                      // // // // // console.log(modifiersArr[modifierGroupIndex].modifierItems);
                      //modifiersObj.modifierItems = [];
                      modifiersItemsObj.modifierTabid = "";
                      modifiersItemsObj.modifierItemId = mdItem.SalesItemOptionId;
                      modifiersItemsObj.modifierItemName = mdItem.modifierItemName;
                      modifiersItemsObj.modifierItemAmount = mdItem.modifierItemAmount;
                      modifiersItemsObj.modifierItemTax = 0;
                      modifiersItemsObj.modifierItemStrikeprice = -1;
                      modifiersItemsObj.modifierItemStrikeValueBeforeTax = 0;
                      modifiersItemsObj.modifierItemStrikeTaxValue = 0;
                      // console.log("else > mdItem.Quantity: " + mdItem.Quantity);
                      modifiersItemsObj.modifierItemQuantity = parseInt(mdItem.Quantity);
                      modifiersArr[modifierGroupIndex].modifierItems.push(modifiersItemsObj);
                    }
                    // // // // // iuiArr.push(mdItem.SalesItemOptionId + mdItem.Quantity);
                  });
                  // // // // // itemObj.itemUniqueIdentifier += iuiArr.sort().join("");
                  // // // // // console.log("modifiersArr");
                  // // // // // console.log(modifiersArr);
                  itemObj.modifierGroups[0] = modifiersArr;

                  // itemObj.modifierGroups[0][0].modifierItems.map((cartItemModifier) => {
                  //   iuiArr.push(cartItemModifier.modifierItemId + cartItemModifier.modifierItemQuantity);
                  // });
                  itemObj.modifierGroups[0].map((modifierGroupItem) => {
                    modifierGroupItem.modifierItems.map((cartItemModifier) => {
                      iuiArr.push(cartItemModifier.modifierItemId + cartItemModifier.modifierItemQuantity);
                    });
                  });
                  itemObj.itemUniqueIdentifier += iuiArr.sort().join("");
                }

                newCartDataArr.push(itemObj);
              } else {
                console.log("else >>> rscItem[menuId] && typeof rscItem[menuId] !== typeof undefined");
              }
            });
          });
          // // // // // console.log("newCartDataArr");
          // // // // // console.log(newCartDataArr);
          console.log("this.state.cartData 0");
          console.log(this.state.cartData);
          this.setState(
            {
              cartData: newCartDataArr,
              setReviewScreenCartDataCount: true,
            },
            () => {
              this.loadStateData();
              console.log("this.state.cartData 1");
              console.log(this.state.cartData);
            }
          );
        }
      }
    );
  };
  setReviewScreenCartData = () => {
    console.log("setReviewScreenCartData()");
    // var menunSelected = document.cookie("menusselected");
    console.log("0 this.state.cartData");
    console.log(this.state.cartData);
    this.setState(
      {
        cartData: [],
      },
      () => {
        console.log("1 this.state.cartData");
        console.log(this.state.cartData);
        let reviewScreenCartData = JSON.parse(localStorage.getItem("fnbCartData"));
        var cookieName = "menusselected";
        var menuSelected = null;
        var cookieArr = document.cookie.split(";");
        for (var i = 0; i < cookieArr.length; i++) {
          var cookiePair = cookieArr[i].split("=");
          if (cookieName === cookiePair[0].trim()) {
            // return decodeURIComponent(cookiePair[1]);
            menuSelected = decodeURIComponent(cookiePair[1]);
          }
        }

        if (menuSelected !== null && reviewScreenCartData !== null) {
          console.log("if > menuSelected !== null && reviewScreenCartData !== null");
          var menuSelectedArr = menuSelected.split("-");
          console.log("menuSelectedArr.length: " + menuSelectedArr.length);
          console.log("Object.keys(reviewScreenCartData).length: " + Object.keys(reviewScreenCartData).length);

          if (menuSelectedArr.length == Object.keys(reviewScreenCartData).length) {
            console.log("if > menuSelectedArr.length == Object.keys(reviewScreenCartData).length");
            var newCartDataArr = [];
            reviewScreenCartData.map((rscItem, index) => {
              console.log("reviewScreenCartData > index:" + index);
              var menuId = menuSelectedArr[index];
              console.log("menuId: " + menuId);
              console.log("rscItem: ");
              console.log(rscItem);
              console.log("rscItem[" + menuId + "]: ");
              console.log(rscItem[menuId]);
              var itemObj = new Object();
              itemObj.tabId = rscItem[menuId].tabId;
              itemObj.tabName = rscItem[menuId].tabName;
              itemObj.itemInCartFlag = true;
              itemObj.id = rscItem[menuId].order_items.MenuItemId;
              itemObj.SalesItemId = rscItem[menuId].order_items.SalesItemId;
              itemObj.itemName = rscItem[menuId].MenuName;
              //>// itemObj.valuebeforetax = Number(rscItem[menuId].ItemPrice - rscItem[menuId].ItemModifiersPrcie).toFixed(2);
              itemObj.valuebeforetax = Number(rscItem[menuId].ItemPrice).toFixed(2);
              itemObj.taxValue = 0;
              itemObj.strikeprice = -1;
              itemObj.strikeValueBeforeTax = 0;
              itemObj.strikeTaxValue = 0;
              // console.log("rscItem[menuId].order_items.Quantity: " + rscItem[menuId].order_items.Quantity);
              itemObj.quantity = parseInt(rscItem[menuId].order_items.Quantity);
              itemObj.modifierGroups = [];
              itemObj.specialinstructions = rscItem[menuId].order_items.SpecialInstructions;
              itemObj.Upsize = rscItem[menuId].order_items.IsUpsize;
              itemObj.PriceDifferent = rscItem[menuId].order_items.PriceDifferent;
              itemObj.modifierGroups = [];
              if (rscItem[menuId].order_items.Modifiers.length == 0) {
                // // // // // console.log("No Modifiers");
                itemObj.itemUniqueIdentifier = itemObj.tabId + "_" + rscItem[menuId].order_items.MenuItemId;
              } else {
                // // // // // console.log("With Modifiers");
                itemObj.itemUniqueIdentifier = rscItem[menuId].order_items.MenuItemId;

                var modifiersArr = [];
                let modifiersData = rscItem[menuId].order_items.Modifiers;
                var iuiArr = []; // itemUniqueIdentifier
                modifiersData.map((mdItem) => {
                  // // // // // console.log("modifiersArr");
                  // // // // // console.log(modifiersArr);
                  var modifiersObj = new Object();
                  var modifiersItemsObj = new Object();
                  var modifierGroupIndex = modifiersArr.findIndex((x) => x.modifierGroupId === mdItem.ItemOptionGroupId);
                  if (modifierGroupIndex == -1) {
                    // // // // // console.log("modifierGroupIndex == -1");
                    modifiersObj.modifierGroupId = mdItem.ItemOptionGroupId;
                    modifiersObj.modifierItems = [];
                    modifiersItemsObj.modifierTabid = "";
                    modifiersItemsObj.modifierItemId = mdItem.SalesItemOptionId;
                    modifiersItemsObj.modifierItemName = mdItem.modifierItemName;
                    modifiersItemsObj.modifierItemAmount = mdItem.modifierItemAmount;
                    modifiersItemsObj.modifierItemTax = 0;
                    modifiersItemsObj.modifierItemStrikeprice = -1;
                    modifiersItemsObj.modifierItemStrikeValueBeforeTax = 0;
                    modifiersItemsObj.modifierItemStrikeTaxValue = 0;
                    // console.log("if > mdItem.Quantity: " + mdItem.Quantity);
                    modifiersItemsObj.modifierItemQuantity = parseInt(mdItem.Quantity);
                    modifiersObj.modifierItems.push(modifiersItemsObj);
                    modifiersArr.push(modifiersObj);
                  } else {
                    // // // // // console.log("modifierGroupIndex == " + modifierGroupIndex);
                    // // // // // console.log(modifiersArr[modifierGroupIndex].modifierItems);
                    //modifiersObj.modifierItems = [];
                    modifiersItemsObj.modifierTabid = "";
                    modifiersItemsObj.modifierItemId = mdItem.SalesItemOptionId;
                    modifiersItemsObj.modifierItemName = mdItem.modifierItemName;
                    modifiersItemsObj.modifierItemAmount = mdItem.modifierItemAmount;
                    modifiersItemsObj.modifierItemTax = 0;
                    modifiersItemsObj.modifierItemStrikeprice = -1;
                    modifiersItemsObj.modifierItemStrikeValueBeforeTax = 0;
                    modifiersItemsObj.modifierItemStrikeTaxValue = 0;
                    // console.log("else > mdItem.Quantity: " + mdItem.Quantity);
                    modifiersItemsObj.modifierItemQuantity = parseInt(mdItem.Quantity);
                    modifiersArr[modifierGroupIndex].modifierItems.push(modifiersItemsObj);
                  }
                  // // // // // iuiArr.push(mdItem.SalesItemOptionId + mdItem.Quantity);
                });
                // // // // // itemObj.itemUniqueIdentifier += iuiArr.sort().join("");
                // // // // // console.log("modifiersArr");
                // // // // // console.log(modifiersArr);
                itemObj.modifierGroups[0] = modifiersArr;

                // itemObj.modifierGroups[0][0].modifierItems.map((cartItemModifier) => {
                //   iuiArr.push(cartItemModifier.modifierItemId + cartItemModifier.modifierItemQuantity);
                // });
                itemObj.modifierGroups[0].map((modifierGroupItem) => {
                  modifierGroupItem.modifierItems.map((cartItemModifier) => {
                    iuiArr.push(cartItemModifier.modifierItemId + cartItemModifier.modifierItemQuantity);
                  });
                });
                itemObj.itemUniqueIdentifier += iuiArr.sort().join("");
              }
              itemObj.IsAlcohol = rscItem[menuId].order_items.IsAlcohol; // Alcohol Item - true/false

              itemObj.salesItemIdPOSItemId = rscItem[menuId].order_items.POSItemId;
              itemObj.salesItemIdPrice = rscItem[menuId].order_items.Price;

              newCartDataArr.push(itemObj);
            });
            // Setting the data in cart.
            this.setState(
              {
                cartData: newCartDataArr,
                setReviewScreenCartDataCount: true,
              },
              () => {
                this.loadStateData();
                console.log("2 this.state.cartData");
                console.log(this.state.cartData);
              }
            );
          } else {
            console.log("else > menuSelectedArr.length == Object.keys(reviewScreenCartData).length");
          }
        } else {
          console.log("else > menuSelected !== null && reviewScreenCartData !== null");
        }
      }
    );
  };

  openRepeatItemDrawer = () => {
    console.log("openRepeatItemDrawer()");
    this.setState(
      {
        repeatItemModalDrawer: true,
      },
      () => {
        // if (this.state.repeatItemModalDrawer) {
        document.body.className += " repeatItemDrawerOpen";
        // } else {
        //   document.body.className = document.body.className.replace("repeatItemDrawerOpen", "");
        // }
      }
    );
  };

  closeRepeatItemDrawer = () => {
    console.log("closeRepeatItemDrawer()");
    this.setState(
      {
        repeatItemModalDrawer: false,
      },
      () => {
        // // // // // this.cartBlockDrawerToggle();
        //>// this.cartDrawerToggle();
        this.state.windowWidth < 992 && this.cartDrawerToggle();
        // if (this.state.repeatItemModalDrawer) {
        //   document.body.className += " repeatItemDrawerOpen";
        // } else {
        document.body.className = document.body.className.replace("repeatItemDrawerOpen", "");
        // }
      }
    );
  };

  handleRepeatillChoose = (event) => {
    try {
      let temp = "";
      this.state.cartData[this.state.cartData.length - 1].modifierGroups?.map((modifierGroupItem) => {
        modifierGroupItem?.map((cartItemModifier) => {
          cartItemModifier?.modifierItems?.map((item) => {
            temp += item.modifierItemName + " (" + item.modifierItemQuantity + "), ";
          });
        });
      });
      window.Moengage.track_event("FnB item select quantity toggle", {
        State: this.state.compHomeSelectedOptions.stateFullString,
        "Cinema Location": this.state.compHomeSelectedOptions.cinemaFullString,
        "Order Method": this.state.compHomeSelectedOptions.deliverOption,
        Showdate: this.state.compHomeSelectedOptions.showDate,
        Moviename: this.state.compHomeSelectedOptions.movieFullString,
        Showtime: this.state.compHomeSelectedOptions.showTimeFullString,
        "Seat number": this.state.compHomeSelectedOptions.seatNumber,
        "Delivery Time": this.state.compHomeSelectedOptions.deliverToSeatTimeFullString,
        "FnB type": this.state.menuItemSelected.Name,
        "FnB Item selected": this.state.fnbItemData.Name,
        "Add on/Topping": temp,
        Quantity: this.state.cartData[this.state.cartData.length - 1].quantity,
        Customisation: "Let me choose",
      });
    } catch (error) {
      console.log(error);
    }
    var tempCartData = this.state.cartData;
    var tempRepeatItemData = this.state.repeatItemData;
    var tempRepeatItemDataId = tempRepeatItemData.id;
    ////////console.log("tempRepeatItemDataId: " + tempRepeatItemDataId);
    //Find tabId(Fnb tabId from cartData).
    // var cartFnbTabIndex = tempCartData.findIndex((x) => x.id == tempRepeatItemDataId);
    var cartFnbTabIndex = tempRepeatItemData.repeatIndex;
    ////////console.log("cartFnbTabIndex: " + cartFnbTabIndex);
    if (cartFnbTabIndex != -1) {
      var cartFnbTabId = tempCartData[cartFnbTabIndex].tabId;
      console.log("cartFnbTabId: " + cartFnbTabId);
      //Find the tab index from this.state.fnbMenuData.
      var fnbTabIndex = this.state.fnbMenuData.findIndex((x) => parseInt(x.MenuId) == parseInt(cartFnbTabId));
      console.log("fnbTabIndex: " + fnbTabIndex);

      /*Find tab index for deal items*/
      // // // // // if (fnbTabIndex == -1 && tempRepeatItemData.dealItem == true) {
      // // // // //   this.state.fnbMenuData.map((fnbTabItem, index) => {
      // // // // //     var fnbItemsData = fnbTabItem.Items;
      // // // // //     var fnbItemsDataIndex = fnbItemsData.findIndex((x) => x.MenuItemId === tempRepeatItemDataId);
      // // // // //     if (fnbItemsDataIndex != -1) {
      // // // // //       fnbTabIndex = index;
      // // // // //     }
      // // // // //   });
      // // // // // }

      if (fnbTabIndex !== -1) {
        //Find the fnb item index from this.state.fnbMenuItems[fnbTabIndex].
        var itemsData = this.state.fnbMenuData[fnbTabIndex].Items;
        // // // // // console.log("itemsData: " + itemsData);
        var fnbItemIndex = itemsData.findIndex((x) => parseInt(x.MenuItemId) == parseInt(tempRepeatItemDataId));
        // // // // // console.log("fnbItemIndex: " + fnbItemIndex);
        if (fnbItemIndex != -1) {
          // // // // // var fnbItem = this.state.fnbMenuData[fnbTabIndex].Items[fnbItemIndex];
          // // // // // var tabId = this.state.fnbMenuData[fnbTabIndex].MenuId;
          // // // // // var tabName = this.state.fnbMenuData[fnbTabIndex].Name;
          // // // // // var dealItemFlag = this.state.fnbMenuData[fnbTabIndex].dealItem;
          // // // // // var ageRestrictionFlag = this.state.fnbMenuData[fnbTabIndex].dealItem;
          this.setState(
            {
              repeatItemIllChoose: true,
            },
            () => {
              setTimeout(() => {
                this.setFnbItemModifierData(this.state.fnbMenuData[fnbTabIndex], this.state.fnbMenuData[fnbTabIndex].Items[fnbItemIndex]);
              }, 500);
            }
          );
        }
      }
    }
  };

  handleRepeatPreviousSelection = (event) => {
    try {
      let temp = "";
      this.state.cartData[this.state.cartData.length - 1].modifierGroups?.map((modifierGroupItem) => {
        modifierGroupItem?.map((cartItemModifier) => {
          cartItemModifier?.modifierItems?.map((item) => {
            temp += item.modifierItemName + " (" + item.modifierItemQuantity + "), ";
          });
        });
      });
      window.Moengage.track_eventt("FnB item select quantity toggle", {
        State: this.state.compHomeSelectedOptions.stateFullString,
        "Cinema Location": this.state.compHomeSelectedOptions.cinemaFullString,
        "Order Method": this.state.compHomeSelectedOptions.deliverOption,
        Showdate: this.state.compHomeSelectedOptions.showDate,
        Moviename: this.state.compHomeSelectedOptions.movieFullString,
        Showtime: this.state.compHomeSelectedOptions.showTimeFullString,
        "Seat number": this.state.compHomeSelectedOptions.seatNumber,
        "Delivery Time": this.state.compHomeSelectedOptions.deliverToSeatTimeFullString,
        "FnB type": this.state.menuItemSelected.Name,
        "FnB Item selected": this.state.fnbItemData.Name,
        "Add on/Topping": temp,
        Quantity: this.state.cartData[this.state.cartData.length - 1].quantity,
        Customisation: "Repeat, please",
      });
    } catch (error) {
      console.log(error);
    }
    var tempRepeatItemData = this.state.repeatItemData;
    var tempRepeatItemDataQty = tempRepeatItemData.quantity;

    var tempCartData = this.state.cartData;
    var findRepeatItemIndex = tempRepeatItemData.repeatIndex;
    if (findRepeatItemIndex != -1) {
      tempCartData[findRepeatItemIndex].quantity = tempRepeatItemDataQty + 1;
      this.setState(
        {
          cartData: tempCartData,
        },
        () => {
          if (tempCartData[findRepeatItemIndex].modifierGroups.length > 0 || this.state.repeatItemModalDrawer) {
            this.closeRepeatItemDrawer();
          }
          //console.log("setting data");
          this.loadStateData();
        }
      );
    }
  };

  alcoholOnChange = (event) => {
    if (event.target.checked) {
      this.setState({alcoholDisableBtn: true});
    } else {
      this.setState({alcoholDisableBtn: false});
    }
  };

  alchocolOkBtn = () => {
    this.setState(
      {
        alcoholAgeValidation: true,
      },
      () => {
        var tempalcholBeverageCheckFNBData = this.state.alcholBeverageCheckFNBData;
        this.setFnbItemModifierData(this.state.menuItemSelected, tempalcholBeverageCheckFNBData.ItemData);
      }
    );
  };

  closeSalesItemDrawer = () => {
    this.setState({
      salesItemModalDrawer: true,
    });
  };

  salesItemDrawerCloseBtn = () => {
    this.setState(
      {
        salesItemModalDrawer: false,
      },
      () => {
        this.hideModifiersDrawer();
      }
    );
  };

  salesItemsOnchange = (e, salesData) => {
    console.log(salesData, "salesData");
    this.setState({
      salesItemsData: salesData,
    });
  };

  salesItemsSubmit = () => {
    var tempSalesItemsData = this.state.salesItemsData;

    // fnbItemData update
    var tempFnbItemData = this.state.fnbItemData;
    tempFnbItemData.Name = tempSalesItemsData.Name;
    tempFnbItemData.Price = tempSalesItemsData.Price;
    tempFnbItemData.selectedSalesItem = tempSalesItemsData.SalesItemId;
    console.log(tempFnbItemData, "tempFnbItemData");

    // Cart update
    var tempCartData = this.state.cartData;
    var getLastIndex = tempCartData.length - 1;
    if (tempCartData[getLastIndex].itemInCartFlag == false) {
      tempCartData[getLastIndex].valuebeforetax = tempSalesItemsData.Price;
      tempCartData[getLastIndex].itemName = tempSalesItemsData.Name;
      tempCartData[getLastIndex].SalesItemId = tempSalesItemsData.SalesItemId;
      tempCartData[getLastIndex].salesItemIdPOSItemId = tempSalesItemsData.POSItemId;
      tempCartData[getLastIndex].salesItemIdPrice = tempSalesItemsData.Price;
      console.log(tempCartData, "tempCartData");
    }

    this.setState(
      {
        salesItemModalDrawer: false,
        fnbItemData: tempFnbItemData,
        cartData: tempCartData,
      },
      () => {
        console.log(this.state.cartData, "cartData");
        this.getModifiers(tempSalesItemsData);
        this.showModifiersDrawer();
      }
    );
  };

  render() {
    let {fnbMenuRedirect, selectionPageRedirect} = this.state;
    return (
      <>
        {this.state.fnbMenuRedirect && (
  <Navigate
    to={`${process.env.REACT_APP_SERVER_FOLDER_NAME}/fnbmenu`}
    replace={false}
  />
)}
        {selectionPageRedirect ? (
          <span>
            {this.setState({selectionPageRedirect: false})}
            <Navigate to={`${process.env.REACT_APP_SERVER_FOLDER_NAME}`} replace={false} />
          </span>
        ) : null}

        <Loader showLoader={this.state.showLoader} />
        <Header />
        <div className="content" id="content">
          <div className="container">
            <div className="row">
              <Routes>
                <Route
                  path={`${process.env.REACT_APP_SERVER_FOLDER_NAME}`}
                  element={<Home key={1} setLoaderState={this.setLoaderState} appState={this.state} callEndPoint={this.callEndPoint} setCompHomeSelectedOptions={this.setCompHomeSelectedOptions} />}
                />
                <Route
                  path={`${process.env.REACT_APP_SERVER_FOLDER_NAME}/fnbmenu`}
                  element={
                    <React.Suspense fallback={<>...</>}>
                      <Menu
                        key={2}
                        appState={this.state}
                        setLoaderState={this.setLoaderState}
                        // setyourSelectionBlock={this.setyourSelectionBlock}
                        handleCategoryTabsUiAnimation={this.handleCategoryTabsUiAnimation}
                        handleOnclickCategoryItem={this.handleOnclickCategoryItem}
                        handleCategoryThumbOnclick={this.handleCategoryThumbOnclick}
                        showModifiersDrawer={this.showModifiersDrawer}
                        getAllMenusBySiteIdnew={this.getAllMenusBySiteIdnew}
                        setFnbItemModifierData={this.setFnbItemModifierData}
                        getModifiers={this.getModifiers}
                        handleInCartFnbItemQuantity={this.handleInCartFnbItemQuantity}
                        populateItemModifierItems={this.populateItemModifierItems}
                        calculateItemRowTotal={this.calculateItemRowTotal}
                        calculateCartSubtotal={this.calculateCartSubtotal}
                        calculateCartTax={this.calculateCartTax}
                        calculateCartGrandTotal={this.calculateCartGrandTotal}
                        deleteItemFromCart={this.deleteItemFromCart}
                        populateCookieData={this.populateCookieData}
                        redirectToSelectionPage={this.redirectToSelectionPage}
                        cartDrawerToggle={this.cartDrawerToggle}
                      />
                    </React.Suspense>
                  }
                />
              </Routes>
            </div>
          </div>
          <div className="pushFooterDiv"></div>
        </div>
        <Footer
          appState={this.state}
          fnbmodifierBodyheight={this.fnbmodifierBodyheight}
          showModifiersDrawer={this.showModifiersDrawer}
          hideModifiersDrawer={this.hideModifiersDrawer}
          modifierItemCounter={this.modifierItemCounter}
          modifierItemCheckboxOnchange={this.modifierItemCheckboxOnchange}
          modifierItemRadioOnchange={this.modifierItemRadioOnchange}
          modifierModalFnbItemSpecialInstructions={this.modifierModalFnbItemSpecialInstructions}
          modifierModalFnbItemQuantity={this.modifierModalFnbItemQuantity}
          addItemToCart={this.addItemToCart}
          openRepeatItemDrawer={this.openRepeatItemDrawer}
          closeRepeatItemDrawer={this.closeRepeatItemDrawer}
          populateItemModifierItems={this.populateItemModifierItems}
          handleRepeatillChoose={this.handleRepeatillChoose}
          handleRepeatPreviousSelection={this.handleRepeatPreviousSelection}
          showUpsizeDrawer={this.showUpsizeDrawer}
          hideUpsizeDrawer={this.hideUpsizeDrawer}
          upsizeItem={this.upsizeItem}
          alcoholOnChange={this.alcoholOnChange}
          alchocolOkBtn={this.alchocolOkBtn}
          closeSalesItemDrawer={this.closeSalesItemDrawer}
          salesItemDrawerCloseBtn={this.salesItemDrawerCloseBtn}
          salesItemsOnchange={this.salesItemsOnchange}
          salesItemsSubmit={this.salesItemsSubmit}
        />
      </>
    );
  }
}

// export default App;
export default function (props) {
  const navigation = useNavigate();
  return <App {...props} navigate={navigation} />;
}
